var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackPlanTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 493,
    viewBox: "0 0 1080 493",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6001_48532)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 493,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.152344 0H1080.21V800H0.152344V0Z",
    fill: "url(#paint0_linear_6001_48532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9742 682.007V663.307C89.9742 565.98 166.608 486.059 263.482 481.687L271.782 473.199C166.845 473.199 81.6777 558.257 81.6777 663.304V682.004H89.9777L89.9742 682.007Z",
    fill: "#BEAEAE",
    stroke: "#3D3B3B",
    strokeWidth: 0.608375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.8481 682.007V663.307C-29.8481 565.98 46.7856 486.059 143.66 481.687L151.96 473.199C47.0224 473.199 -38.1445 558.257 -38.1445 663.304V682.004H-29.8445L-29.8481 682.007Z",
    fill: "#BEAEAE",
    stroke: "#3D3B3B",
    strokeWidth: 0.608375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.216 682.007V663.307C195.216 565.984 271.847 486.059 368.725 481.687L377.025 473.199C272.087 473.199 186.92 558.257 186.92 663.304V682.004H195.22L195.216 682.007Z",
    fill: "#BEAEAE",
    stroke: "#3D3B3B",
    strokeWidth: 0.608375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.459 682.007V663.307C300.459 565.987 377.085 486.059 473.967 481.687L482.267 473.199C377.329 473.199 292.162 558.257 292.162 663.304V682.004H300.462L300.459 682.007Z",
    fill: "#BEAEAE",
    stroke: "#3D3B3B",
    strokeWidth: 0.608375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.702 682.007V663.307C405.702 565.991 482.325 486.059 579.21 481.687L587.51 473.199C482.572 473.199 397.405 558.257 397.405 663.304V682.004H405.705L405.702 682.007Z",
    fill: "#BEAEAE",
    stroke: "#3D3B3B",
    strokeWidth: 0.608375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.942 682.007V663.307C510.942 565.995 587.561 486.059 684.45 481.687L692.75 473.199C587.812 473.199 502.646 558.257 502.646 663.304V682.004H510.946L510.942 682.007Z",
    fill: "#BEAEAE",
    stroke: "#3D3B3B",
    strokeWidth: 0.608375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.192 682.007V663.307C616.192 565.998 692.808 486.059 789.7 481.687L798 473.199C693.062 473.199 607.896 558.257 607.896 663.304V682.004H616.196L616.192 682.007Z",
    fill: "#BEAEAE",
    stroke: "#3D3B3B",
    strokeWidth: 0.608375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.433 682.007V663.307C721.433 566.002 798.046 486.059 894.941 481.687L903.241 473.199C798.304 473.199 713.137 558.257 713.137 663.304V682.004H721.437L721.433 682.007Z",
    fill: "#BEAEAE",
    stroke: "#3D3B3B",
    strokeWidth: 0.608375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.676 682.007V663.307C826.676 566.005 903.285 486.059 1000.18 481.687L1008.48 473.199C903.547 473.199 818.38 558.257 818.38 663.304V682.004H826.68L826.676 682.007Z",
    fill: "#BEAEAE",
    stroke: "#3D3B3B",
    strokeWidth: 0.608375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.128 682.007V663.307C936.128 566.005 1012.74 486.059 1109.64 481.687L1117.94 473.199C1013 473.199 927.832 558.257 927.832 663.304V682.004H936.132L936.128 682.007Z",
    fill: "#BEAEAE",
    stroke: "#3D3B3B",
    strokeWidth: 0.608375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.31 492.076H-52.5586V502.943H1121.31V492.076Z",
    fill: "#BEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M-58.29 812.076V492.184L1109.79 491.699V812.076H-58.29Z",
    fill: "url(#paint1_linear_6001_48532)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.3739 221.541H83.3552V221.564H83.3739V221.541Z",
    fill: "url(#paint2_linear_6001_48532)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M862.46 150.822L863.358 100.097L864.862 150.967C865.199 150.967 865.475 151.242 865.475 151.578V157.675H866.089C866.426 157.675 866.702 157.95 866.702 158.286V160.744C867.147 161.15 867.447 161.714 867.503 162.354L867.63 163.94C867.826 166.263 867.822 168.6 867.606 170.923L867.513 171.921C867.41 173.041 866.557 173.927 865.475 174.104V179.623H866.089C866.426 179.623 866.702 179.898 866.702 180.234V180.845C866.702 181.181 866.426 181.456 866.089 181.456H865.475V184.502H866.089C866.426 184.502 866.702 184.777 866.702 185.113V186.331C866.702 186.667 866.426 186.942 866.089 186.942H865.475V191.816H866.089C866.426 191.816 866.702 192.092 866.702 192.428V193.645C866.702 193.981 866.426 194.256 866.089 194.256H865.475V194.867H866.089C866.426 194.867 866.702 195.142 866.702 195.478V196.696C866.702 197.032 866.426 197.307 866.089 197.307H865.475V198.524H866.698C867.035 198.524 867.311 198.8 867.311 199.136V203.404C867.311 203.74 867.035 204.015 866.698 204.015H866.084V216.815C866.421 216.815 866.698 217.09 866.698 217.426V218.644C866.698 218.98 866.421 219.255 866.084 219.255V220.472C866.421 220.472 866.698 220.748 866.698 221.084V222.301C866.698 222.637 866.421 222.912 866.084 222.912V236.93H867.306C867.644 236.93 867.92 237.205 867.92 237.541V243.904H872.547C873.216 243.904 873.769 244.45 873.769 245.121V246.068H886.295V242.248C886.295 241.884 886.005 241.59 885.64 241.59C885.275 241.59 884.98 241.296 884.98 240.932V238.614C884.98 238.082 884.544 237.648 884.005 237.648C883.336 237.648 882.863 236.972 883.102 236.342L888.904 221.098C889.082 220.622 889.531 220.309 890.046 220.309H962.34C962.776 220.309 963.174 220.533 963.394 220.906L972.558 236.351C972.895 236.925 972.488 237.648 971.814 237.648C971.345 237.648 970.952 238.031 970.952 238.507V240.368C970.952 241.04 970.409 241.585 969.73 241.585H969.542C968.873 241.585 968.32 242.131 968.32 242.803V246.059H976.361V216.647C976.361 216.344 976.609 216.097 976.913 216.097C977.218 216.097 977.471 215.85 977.471 215.546V204.617C977.471 203.945 978.014 203.399 978.693 203.399H998.867V202.182C998.867 201.51 999.414 200.964 1000.09 200.964H1005.61C1006.15 200.964 1006.63 200.614 1006.78 200.101L1009.62 190.856C1009.77 190.342 1010.25 189.993 1010.79 189.993H1079.94C1080.61 189.993 1081.16 190.538 1081.16 191.21V246.064V310.467H776.44H296.139H-1.47461V234.406V231.16C-1.47461 230.488 -0.926723 229.942 -0.252392 229.942H0.407906C1.08224 229.942 1.63012 229.396 1.63012 228.724V222.828C1.63012 222.156 2.17801 221.611 2.85234 221.611H25.0256C25.7 221.611 26.2478 222.156 26.2478 222.828V228.724C26.2478 229.396 26.7957 229.942 27.4701 229.942H29.8302C30.4905 229.942 31.0244 230.474 31.0244 231.132C31.0244 231.789 31.5582 232.321 32.2185 232.321H38.8915C39.3458 232.321 39.7673 232.573 39.9733 232.974L44.511 241.581C44.6046 241.753 44.6515 241.949 44.6515 242.145V246.591H49.9056V238.021C49.9056 237.294 50.9639 237.182 51.1185 237.896L51.3995 239.202L53.0619 239.197L53.2351 238.031C53.3335 237.35 54.3122 237.326 54.4386 238.003L54.6634 239.169V239.202L57.9555 239.197L58.1287 238.031C58.2271 237.35 59.2058 237.326 59.3322 238.003L59.557 239.169V239.202L60.3999 239.197L60.5732 238.031C60.6715 237.35 61.6502 237.326 61.7766 238.003L61.9968 239.169C62.0015 239.174 62.0015 239.188 62.0015 239.188V239.202L62.2356 239.197L62.4089 238.031C62.5072 237.35 63.4859 237.326 63.6123 238.003L63.8371 239.169V239.188V239.202H64.1836L64.4646 237.896C64.6191 237.177 65.6775 237.289 65.6775 238.021V246.591H78.8457V213.083H78.944L79.0657 212.006C79.15 211.301 80.1709 211.278 80.2833 211.982L80.4472 213.083H80.9295L81.0513 212.006C81.1402 211.301 82.1611 211.278 82.2641 211.982L82.4514 213.209H87.1249L87.2607 212.006C87.345 211.301 88.3659 211.278 88.4783 211.982L88.6609 213.209H89.1151L89.2509 212.006C89.3399 211.301 90.3608 211.278 90.4638 211.982L90.6511 213.209H90.8899V221.489H93.9994V203.185H94.1914V203.161V203.124L94.4255 200.899C94.5004 200.157 95.5868 200.171 95.643 200.913L95.8163 203.138V203.185H98.6682V203.124L98.9023 200.899C98.9772 200.157 100.064 200.171 100.12 200.913L100.293 203.138V203.185H100.967V186.601H101.52L101.675 185.967C101.834 185.328 102.752 185.356 102.873 185.999L102.986 186.597H103.379L105.692 179.912L106.592 166.794H106.559C105.533 166.794 104.7 165.964 104.7 164.938C104.7 163.912 105.524 163.081 106.559 163.081C107.594 163.081 108.427 163.912 108.427 164.938C108.427 165.885 107.711 166.668 106.793 166.78L107.804 179.912L109.879 186.597H110.16L110.614 185.23C110.806 184.651 111.644 184.679 111.79 185.276L112.113 186.601H112.155V186.802C112.159 186.844 112.159 186.886 112.155 186.923V203.185H113.836V203.161V203.124L114.07 200.899C114.145 200.157 115.231 200.171 115.288 200.913L115.461 203.138V203.185L115.578 203.18V203.152C115.578 203.143 115.583 203.124 115.583 203.124L115.807 200.899C115.882 200.157 116.969 200.171 117.025 200.913L117.198 203.138C117.198 203.152 117.203 203.185 117.203 203.185H117.376V221.489H118.369V213.209H118.608L118.795 211.982C118.907 211.283 119.928 211.301 120.008 212.006L120.148 213.209H120.593L120.781 211.982C120.893 211.283 121.914 211.301 121.993 212.006L122.134 213.209H126.803L126.99 211.982C127.102 211.283 128.123 211.301 128.203 212.006L128.329 213.083H128.807L128.98 211.982C129.093 211.283 130.114 211.301 130.193 212.006L130.32 213.083H130.54V246.591H138.444L138.369 237.191C138.36 236.468 139.4 236.337 139.573 237.042L140.069 239.071H140.552L140.73 237.42C140.809 236.706 141.844 236.687 141.947 237.396L142.186 239.066H142.387L142.565 237.415C142.645 236.701 143.68 236.683 143.783 237.392L144.022 239.062H144.223L144.401 237.41C144.48 236.697 145.515 236.678 145.618 237.387L145.857 239.057H146.672L146.85 237.406C146.93 236.692 147.965 236.673 148.068 237.382L148.306 239.052H148.508L148.686 237.401C148.765 236.687 149.8 236.669 149.903 237.378L150.161 239.174H150.943L151.135 237.401C151.214 236.687 152.249 236.669 152.352 237.378L152.61 239.174H152.905L153.317 237.504C153.495 236.804 154.525 236.93 154.521 237.653L154.483 246.567H161.301V226.411C161.301 226.005 161.095 225.622 160.758 225.398L160.599 225.296C160.257 225.067 160.056 224.685 160.056 224.279V223.528C160.056 222.856 160.604 222.31 161.278 222.31H161.381C161.84 222.31 162.266 222.054 162.472 221.648L167.614 211.656C167.824 211.25 168.246 210.994 168.705 210.994H204.032C204.51 210.994 204.945 211.269 205.147 211.698L209.97 222.068C210.045 222.226 210.087 222.404 210.087 222.581V226.453C210.087 226.756 210.335 227.003 210.64 227.003C210.944 227.003 211.197 227.25 211.197 227.554V246.567H246.843L264.347 231.621C264.572 231.435 264.848 231.332 265.143 231.332H271.573C271.868 231.332 272.154 231.439 272.374 231.631L275.052 233.954L279.679 181.353H281.819L290.567 246.567H296.139V224.097C296.139 223.845 296.219 223.598 296.364 223.393L308.282 206.548C308.404 206.375 308.563 206.245 308.736 206.161V205.727H344.846C345.384 205.727 345.862 206.077 346.016 206.59L348.854 215.836C349.009 216.349 349.486 216.699 350.025 216.699H355.546C356.216 216.699 356.768 217.244 356.768 217.916V250.22H367.782V224.064C367.782 223.831 367.852 223.603 367.979 223.407L378.304 207.397C378.871 206.511 380.22 206.711 380.505 207.724L392.559 250.22H406.036V242.136C406.036 241.772 405.746 241.478 405.381 241.478C405.015 241.478 404.72 241.184 404.72 240.82V238.502C404.72 237.97 404.285 237.536 403.746 237.536C403.077 237.536 402.604 236.86 402.843 236.23L408.645 220.986C408.822 220.51 409.272 220.197 409.787 220.197H441.902C442.197 220.197 442.436 219.964 442.436 219.67C442.436 219.376 442.197 219.143 441.902 219.143H441.64C441.204 219.143 440.849 218.788 440.849 218.355V218.224C440.849 217.716 441.265 217.305 441.771 217.305H456.803C457.454 217.305 457.988 217.832 457.988 218.485V218.877C457.988 219.311 457.632 219.665 457.192 219.665H456.667C456.522 219.665 456.405 219.782 456.405 219.927C456.405 220.071 456.522 220.188 456.667 220.188H482.076C482.512 220.188 482.91 220.412 483.13 220.785L492.294 236.23C492.632 236.804 492.224 237.527 491.55 237.527C491.081 237.527 490.688 237.91 490.688 238.385V240.247C490.688 240.918 490.145 241.464 489.466 241.464H489.274C488.604 241.464 488.052 242.01 488.052 242.682V245.938H496.092V215.915C496.092 215.612 496.34 215.364 496.645 215.364C496.949 215.364 497.202 215.117 497.202 214.814V203.884C497.202 203.213 497.745 202.667 498.424 202.667H546.55C547.22 202.667 547.772 203.213 547.772 203.884V214.814C547.772 215.117 548.02 215.364 548.325 215.364C548.629 215.364 548.882 215.612 548.882 215.915V219.707H560.884L563.605 210.84C563.759 210.326 564.237 209.977 564.776 209.977H599.663C600.332 209.977 600.885 210.522 600.885 211.194V219.707H642.815L647.906 209.799C648.116 209.394 648.538 209.137 648.997 209.137H684.324C684.802 209.137 685.237 209.412 685.439 209.841L690.262 220.211C690.337 220.37 690.379 220.547 690.379 220.724V224.596C690.379 224.899 690.627 225.147 690.931 225.147C691.236 225.147 691.489 225.394 691.489 225.697V245.933H725.711L744.986 229.476H752.328L771.294 245.933H776.44V222.245C776.44 221.993 776.52 221.746 776.665 221.541L788.583 204.696C788.705 204.523 788.864 204.393 789.037 204.309V203.875H825.147C825.685 203.875 826.163 204.225 826.318 204.738L829.155 213.984C829.31 214.497 829.787 214.847 830.326 214.847H835.847C836.517 214.847 837.069 215.392 837.069 216.064V245.928H848.083V244.981C848.083 244.31 848.631 243.764 849.306 243.764H859.402V237.401C859.402 237.065 859.678 236.79 860.015 236.79H861.237V222.772C860.9 222.772 860.624 222.497 860.624 222.161V220.944C860.624 220.608 860.9 220.332 861.237 220.332V219.115C860.9 219.115 860.624 218.84 860.624 218.504V217.286C860.624 216.951 860.9 216.675 861.237 216.675V203.875H860.624C860.287 203.875 860.011 203.6 860.011 203.264V198.996C860.011 198.66 860.287 198.385 860.624 198.385H861.846V197.167H861.233C860.896 197.167 860.619 196.892 860.619 196.556V195.338C860.619 195.003 860.896 194.727 861.233 194.727H861.846V194.116H861.233C860.896 194.116 860.619 193.841 860.619 193.505V192.288C860.619 191.952 860.896 191.677 861.233 191.677H861.846V186.802H861.233C860.896 186.802 860.619 186.527 860.619 186.191V184.973C860.619 184.637 860.896 184.362 861.233 184.362H861.846V181.316H861.233C860.896 181.316 860.619 181.041 860.619 180.705V180.094C860.619 179.758 860.896 179.483 861.233 179.483H861.846V173.992C860.783 173.932 859.893 173.129 859.748 172.061C859.313 168.889 859.294 165.68 859.692 162.507L859.739 162.097C859.823 161.453 860.146 160.898 860.619 160.516V158.141C860.619 157.805 860.896 157.53 861.233 157.53H861.846V151.433C861.846 151.097 862.123 150.822 862.46 150.822ZM83.3739 221.541H83.3552V221.564H83.3739V221.541Z",
    fill: "url(#paint3_linear_6001_48532)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.32 303.004H-19.1104V321.206H1337.32V303.004Z",
    fill: "#CFCDC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.458 308.795L1329.77 308.689",
    stroke: "white",
    strokeWidth: 0.586867,
    strokeDasharray: "2.93 2.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6006 251.915H-11.917V276.323H28.6006V251.915Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6677 270.53H-11.8721V276.321H28.6677V270.53Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0812 263.703H-12.2881V268.873H29.0812V263.703Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6677 270.53H-11.8721V276.321H28.6677V270.53Z",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3653 270.53H-1.94336V276.321H1.3653V270.53Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32916 270.53H3.02051V276.321H6.32916V270.53Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2911 270.53H7.98242V276.321H11.2911V270.53Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2559 270.53H12.9473V276.321H16.2559V270.53Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2208 270.53H17.9121V276.321H21.2208V270.53Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1856 270.53H22.877V276.321H26.1856V270.53Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0812 256.26H-12.2881V262.051H29.0812V256.26Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0812 256.26H-12.2881V257.086H29.0812V256.26Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0812 263.703H-12.2881V264.53H29.0812V263.703Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0812 270.53H-12.2881V271.357H29.0812V270.53Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0812 251.915H-12.2881V254.603H29.0812V251.915Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0812 251.915H-12.2881V252.741H29.0812V251.915Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2877 253.568H-12.4932V254.809H29.2877V253.568Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.60651 256.26H-0.702148V259.983H2.60651V256.26Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32916 256.26H3.02051V259.983H6.32916V256.26Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0499 256.26H6.74121V259.983H10.0499V256.26Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7725 256.26H10.4639V259.983H13.7725V256.26Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4971 256.26H14.1885V259.983H17.4971V256.26Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2208 256.26H17.9121V259.983H21.2208V256.26Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9434 256.26H21.6348V259.983H24.9434V256.26Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6671 256.26H25.3584V259.983H28.6671V256.26Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.60651 263.703H-0.702148V267.012H2.60651V263.703Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32916 263.703H3.02051V267.012H6.32916V263.703Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0499 263.703H6.74121V267.012H10.0499V263.703Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7725 263.703H10.4639V267.012H13.7725V263.703Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4971 263.703H14.1885V267.012H17.4971V263.703Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2208 263.703H17.9121V267.012H21.2208V263.703Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9434 263.703H21.6348V267.012H24.9434V263.703Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6671 263.703H25.3584V267.012H28.6671V263.703Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.985 293.946L326.965 292.863C330.308 292.651 333.152 290.34 334.041 287.11L334.437 285.67C334.617 285.014 334.63 284.327 334.478 283.665L334.111 282.098C333.253 278.416 328.051 278.308 327.041 281.952L325.714 279.41C323.878 275.892 318.609 276.817 318.074 280.746C316.662 275.592 309.494 275.215 307.55 280.195L307.471 280.395L306.581 279.448C304.064 276.763 299.764 276.887 297.402 279.711C295.325 282.196 295.537 285.869 297.89 288.098L300.059 290.15C297.754 291.353 298.764 294.851 301.357 294.642L309.981 293.943L309.985 293.946Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.649 293.946L419.63 292.863C422.976 292.651 425.813 290.34 426.709 287.11L427.105 285.67C427.282 285.014 427.298 284.327 427.143 283.665L426.779 282.098C425.918 278.416 420.719 278.308 419.706 281.952L418.382 279.41C416.546 275.892 411.274 276.817 410.742 280.746C409.33 275.592 402.162 275.215 400.218 280.195L400.139 280.395L399.249 279.448C396.735 276.763 392.432 276.887 390.07 279.711C387.993 282.196 388.205 285.869 390.558 288.098L392.727 290.15C390.422 291.353 391.432 294.851 394.025 294.642L402.649 293.943V293.946Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.347 293.946L277.327 292.863C280.671 292.651 283.514 290.34 284.404 287.11L284.799 285.67C284.98 285.014 284.992 284.327 284.84 283.665L284.473 282.098C283.615 278.416 278.413 278.308 277.403 281.952L276.077 279.41C274.24 275.892 268.972 276.817 268.437 280.746C267.024 275.592 259.856 275.215 257.912 280.195L257.833 280.395L256.943 279.448C254.426 276.763 250.126 276.887 247.765 279.711C245.688 282.196 245.9 285.869 248.252 288.098L250.421 290.15C248.116 291.353 249.126 294.851 251.719 294.642L260.344 293.943L260.347 293.946Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.951 290.771L372.276 285.974C375.49 285.031 377.754 282.15 377.912 278.803L377.981 277.312C378.013 276.634 377.874 275.96 377.579 275.349L376.877 273.899C375.227 270.498 370.129 271.537 369.946 275.314L368.09 273.126C365.526 270.099 360.59 272.16 360.935 276.112C358.421 271.394 351.344 272.607 350.547 277.894L350.515 278.106L349.438 277.378C346.389 275.314 342.223 276.381 340.545 279.658C339.066 282.539 340.082 286.076 342.869 287.732L345.436 289.258C343.454 290.939 345.208 294.13 347.691 293.355L355.951 290.774V290.771Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.65 287.196L469.368 282.833C466.68 281.418 465.049 278.584 465.173 275.551L465.293 272.714C465.321 271.98 465.533 271.267 465.91 270.634L466.911 268.937C469.004 265.397 474.437 266.999 474.269 271.109L476.59 268.763C479.623 265.698 484.793 268.373 484.043 272.619C487.219 267.667 494.878 269.662 495.239 275.535L496.518 274.794C500.016 272.768 504.496 274.294 506.032 278.033C507.352 281.253 505.969 284.948 502.863 286.512L499.709 288.105H481.314C480.035 288.105 478.778 287.795 477.647 287.199L477.65 287.196Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.868 285.706L469.192 283.553C467.273 282.011 466.187 279.659 466.26 277.199L466.355 274.013C466.371 273.336 466.561 272.674 466.906 272.088L467.717 270.698C469.62 267.434 474.622 268.859 474.518 272.636L476.531 270.597C479.321 267.776 484.086 270.204 483.44 274.121C486.305 269.609 493.268 271.357 493.664 276.689L493.679 276.904L496.133 275.261C498.492 273.684 501.582 273.738 503.881 275.397L504.717 275.999C506.822 277.518 507.582 280.305 506.54 282.686C506.024 283.876 505.097 284.842 503.935 285.418L497.894 288.41H483.44L475.749 287.378C474.331 287.188 472.985 286.612 471.868 285.712V285.706Z",
    fill: "#6F9392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.943 271.81H380.062V282.942H393.943V271.81Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.012 271.373H379.992V271.649H394.012V271.373Z",
    stroke: "#615E66",
    strokeWidth: 0.208968
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.256 269.586L380.227 271.261H393.781L392.752 269.586C392.638 269.403 392.439 269.292 392.223 269.292H381.784C381.569 269.292 381.37 269.403 381.256 269.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.943 279.138H380.062V282.94H393.943V279.138Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.399 280.24H381.348V281.659H382.399V280.24Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.781 280.24H383.729V281.659H384.781V280.24Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.912 280.24H388.86V281.659H389.912V280.24Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.477 280.24H391.426V281.659H392.477V280.24Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.296 275.476H391.609V278.176H392.296V275.476Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.296 272.54H391.609V273.775H392.296V272.54Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.732 275.476H389.229V278.176H389.732V275.476Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.732 272.54H389.229V273.775H389.732V272.54Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.165 275.476H386.661V278.176H387.165V275.476Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.165 272.54H386.661V273.775H387.165V272.54Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.6 275.476H384.097V278.176H384.6V275.476Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.6 272.54H384.097V273.775H384.6V272.54Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.215 275.476H381.712V278.176H382.215V275.476Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.215 272.54H381.712V273.775H382.215V272.54Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.528 280.24H386.477V282.941H387.528V280.24Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.864 266.807H516.347V282.941H556.864V266.807Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.864 278.128H516.347V282.941H556.864V278.128Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.985 270.074H518.311V272.056H518.985V270.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.163 267.908H515.053V268.56H558.163V267.908Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.985 274.646H518.311V276.628H518.985V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.204 279.217H517.222V282.94H519.204V279.217Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.431 279.217H521.359V282.94H524.431V279.217Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.222 279.217H526.15V282.94H529.222V279.217Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.011 279.217H530.939V282.94H534.011V279.217Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.291 279.884C535.291 279.155 535.883 278.566 536.611 278.566C537.34 278.566 537.925 279.155 537.925 279.884V282.942H535.291V279.884Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.285 279.217H539.214V282.94H542.285V279.217Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.076 279.217H544.005V282.94H547.076V279.217Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.081 279.217H549.01V282.94H552.081V279.217Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.781 279.217H554.018V282.94H555.781V279.217Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.686 270.074H522.012V272.056H522.686V270.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.686 274.646H522.012V276.628H522.686V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.083 270.074H524.408V272.056H525.083V270.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.083 274.646H524.408V276.628H525.083V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.476 270.074H526.802V272.056H527.476V270.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.476 274.646H526.802V276.628H527.476V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.651 270.074H528.977V272.056H529.651V270.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.651 274.646H528.977V276.628H529.651V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.267 270.074H531.593V272.056H532.267V270.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.267 274.646H531.593V276.628H532.267V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.442 270.074H533.768V272.056H534.442V270.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.442 274.646H533.768V276.628H534.442V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.057 270.074H536.383V272.056H537.057V270.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.057 274.646H536.383V276.628H537.057V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.67 270.074H538.995V272.056H539.67V270.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.67 274.646H538.995V276.628H539.67V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.063 270.074H541.389V272.056H542.063V270.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.063 274.646H541.389V276.628H542.063V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.239 270.074H543.564V272.056H544.239V270.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.239 274.646H543.564V276.628H544.239V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.854 270.074H546.18V272.056H546.854V270.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.854 274.646H546.18V276.628H546.854V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.252 270.074H548.577V272.056H549.252V270.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.252 274.646H548.577V276.628H549.252V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.425 270.074H550.751V272.056H551.425V270.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.425 274.646H550.751V276.628H551.425V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.909 270.074H554.234V272.056H554.909V270.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.909 274.646H554.234V276.628H554.909V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.523 266.807H515.698V267.918H557.523V266.807Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.274 266.807H413.757V282.941H454.274V266.807Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.341 279.217H413.802V282.94H454.341V279.217Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.391 270.074H415.717V272.056H416.391V270.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.573 267.908H412.462V268.56H455.573V267.908Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.341 274.667H413.802V277.976H454.341V274.667Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.699 279.217H413.802V282.94H416.699V279.217Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.341 279.217H413.802V282.94H454.341V279.217Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.837 279.217H418.766V282.94H421.837V279.217Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.453 279.217H424.145V282.94H427.453V279.217Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.418 279.217H428.347V282.94H431.418V279.217Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.7 279.884C432.7 279.155 433.292 278.566 434.021 278.566C434.749 278.566 435.334 279.155 435.334 279.884V282.942H432.7V279.884Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.691 279.217H436.62V282.94H439.691V279.217Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.481 279.217H441.41V282.94H444.481V279.217Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.487 279.217H446.416V282.94H449.487V279.217Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.343 279.217H451.446V282.94H454.343V279.217Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.171 269.703H413.802V273.427H455.171V269.703Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.171 269.703H413.802V270.118H455.171V269.703Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.171 274.667H413.802V275.082H455.171V274.667Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.171 279.217H413.802V279.632H455.171V279.217Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.314 274.646H451.64V276.628H452.314V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.932 266.807H413.106V268.33H454.932V266.807Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.171 266.807H413.802V267.221H455.171V266.807Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.286 266.807H873.769V282.941H914.286V266.807Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.352 279.217H873.812V282.94H914.352V279.217Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.403 270.074H875.729V272.056H876.403V270.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.584 267.908H872.474V268.56H915.584V267.908Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.352 274.667H873.812V277.976H914.352V274.667Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.71 279.217H873.812V282.94H876.71V279.217Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.352 279.217H873.812V282.94H914.352V279.217Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.849 279.217H878.777V282.94H881.849V279.217Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.462 279.217H884.153V282.94H887.462V279.217Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.43 279.217H888.358V282.94H891.43V279.217Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.709 279.884C892.709 279.155 893.301 278.566 894.029 278.566C894.757 278.566 895.343 279.155 895.343 279.884V282.942H892.709V279.884Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.702 279.217H896.631V282.94H899.702V279.217Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.493 279.217H901.422V282.94H904.493V279.217Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.498 279.217H906.427V282.94H909.498V279.217Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.356 279.217H911.459V282.94H914.356V279.217Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.182 269.703H873.812V273.427H915.182V269.703Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.182 269.703H873.812V270.118H915.182V269.703Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.182 274.667H873.812V275.082H915.182V274.667Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.182 279.217H873.812V279.632H915.182V279.217Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.326 274.646H911.651V276.628H912.326V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.945 266.807H873.12V268.33H914.945V266.807Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.182 266.807H873.812V267.221H915.182V266.807Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.91 258.533H1007.39V282.941H1047.91V258.533Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.97 277.15H1007.43V282.941H1047.97V277.15Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.02 263.434H1009.35V266.612H1010.02V263.434Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.38 270.324H1007.02V275.495H1048.38V270.324Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.33 277.15H1007.43V282.941H1010.33V277.15Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.97 277.15H1007.43V282.941H1047.97V277.15Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.71 277.15H1012.4V282.941H1015.71V277.15Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.67 277.15H1017.36V282.941H1020.67V277.15Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.63 277.15H1022.32V282.941H1025.63V277.15Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.6 277.15H1027.29V282.941H1030.6V277.15Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.56 277.15H1032.25V282.941H1035.56V277.15Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.52 277.15H1037.22V282.941H1040.52V277.15Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.49 277.15H1042.18V282.941H1045.49V277.15Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.39 262.877H1007.02V268.668H1048.39V262.877Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.39 262.877H1007.02V263.703H1048.39V262.877Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.39 270.324H1007.02V271.151H1048.39V270.324Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.39 277.15H1007.02V277.977H1048.39V277.15Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.39 258.533H1007.02V261.221H1048.39V258.533Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.39 258.533H1007.02V259.36H1048.39V258.533Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.59 260.189H1006.81V261.431H1048.59V260.189Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.74 262.877H1007.43V266.6H1010.74V262.877Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.46 262.877H1011.16V266.6H1014.46V262.877Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.18 262.877H1014.88V266.6H1018.18V262.877Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.91 262.877H1018.6V266.6H1021.91V262.877Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.63 262.877H1022.32V266.6H1025.63V262.877Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.35 262.877H1026.05V266.6H1029.35V262.877Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.08 262.877H1029.77V266.6H1033.08V262.877Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.8 262.877H1033.49V266.6H1036.8V262.877Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.52 262.877H1037.22V266.6H1040.52V262.877Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.25 262.877H1040.94V266.6H1044.25V262.877Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.97 262.877H1044.66V266.6H1047.97V262.877Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.74 270.324H1007.43V273.633H1010.74V270.324Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.46 270.324H1011.16V273.633H1014.46V270.324Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.18 270.324H1014.88V273.633H1018.18V270.324Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.91 270.324H1018.6V273.633H1021.91V270.324Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.63 270.324H1022.32V273.633H1025.63V270.324Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.35 270.324H1026.05V273.633H1029.35V270.324Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.08 270.324H1029.77V273.633H1033.08V270.324Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.8 270.324H1033.49V273.633H1036.8V270.324Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.52 270.324H1037.22V273.633H1040.52V270.324Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.25 270.324H1040.94V273.633H1044.25V270.324Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.97 270.324H1044.66V273.633H1047.97V270.324Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.922 266.807H808.404V282.941H848.922V266.807Z",
    fill: "#E4D4B1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.922 278.127H808.404V282.94H848.922V278.127Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.04 270.073H810.365V272.055H811.04V270.073Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.22 267.908H807.109V268.56H850.22V267.908Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.04 274.646H810.365V276.628H811.04V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.261 279.217H809.279V282.94H811.261V279.217Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.484 279.217H813.413V282.94H816.484V279.217Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.275 279.217H818.204V282.94H821.275V279.217Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.064 279.217H822.993V282.94H826.064V279.217Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.348 279.883C827.348 279.154 827.94 278.565 828.668 278.565C829.396 278.565 829.982 279.154 829.982 279.883V282.941H827.348V279.883Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.339 279.217H831.268V282.94H834.339V279.217Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.13 279.217H836.059V282.94H839.13V279.217Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.136 279.217H841.064V282.94H844.136V279.217Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.841 279.217H846.077V282.94H847.841V279.217Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.744 270.073H814.069V272.055H814.744V270.073Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.744 274.646H814.069V276.628H814.744V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.137 270.073H816.463V272.055H817.137V270.073Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.137 274.646H816.463V276.628H817.137V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.534 270.073H818.859V272.055H819.534V270.073Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.534 274.646H818.859V276.628H819.534V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.709 270.073H821.034V272.055H821.709V270.073Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.709 274.646H821.034V276.628H821.709V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.324 270.073H823.649V272.055H824.324V270.073Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.324 274.646H823.649V276.628H824.324V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.5 270.073H825.825V272.055H826.5V270.073Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.5 274.646H825.825V276.628H826.5V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.115 270.073H828.44V272.055H829.115V270.073Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.115 274.646H828.44V276.628H829.115V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.723 270.073H831.049V272.055H831.723V270.073Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.723 274.646H831.049V276.628H831.723V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.12 270.073H833.445V272.055H834.12V270.073Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.12 274.646H833.445V276.628H834.12V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.296 270.073H835.621V272.055H836.296V270.073Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.296 274.646H835.621V276.628H836.296V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.911 270.073H838.236V272.055H838.911V270.073Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.911 274.646H838.236V276.628H838.911V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.304 270.073H840.63V272.055H841.304V270.073Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.304 274.646H840.63V276.628H841.304V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.48 270.073H842.806V272.055H843.48V270.073Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.48 274.646H842.806V276.628H843.48V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.966 270.073H846.292V272.055H846.966V270.073Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.966 274.646H846.292V276.628H846.966V274.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.58 266.807H807.755V267.918H849.58V266.807Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.601 258.368H241.796V282.941H249.601V258.368Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.193 259.691H249.755V282.941H253.193V259.691Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.546 258.368H243.851V282.941H247.546V258.368Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.157 258.368H253.353V282.941H261.157V258.368Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.102 258.368H255.407V282.941H259.102V258.368Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.099 258.368H257.459V282.941H259.099V258.368Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.542 258.368H245.902V282.941H247.542V258.368Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.12 254.256H244.99V258.264H245.12V254.256Z",
    stroke: "#615E66",
    strokeWidth: 0.0981516
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.662 256.903H246.532V258.265H246.662V256.903Z",
    stroke: "#615E66",
    strokeWidth: 0.0981516
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.676 259.691H863.237V282.941H866.676V259.691Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.224 253.568H866.365V282.941H874.224V253.568Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.157 253.568H868.434V282.941H872.157V253.568Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.159 253.568H870.503V282.941H872.159V253.568Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.508 247.366H704.203V282.941H719.508V247.366Z",
    fill: "#D8D1C3",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.926 246.536H703.791V246.951H719.926V246.536Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.407 247.366H704.308V249.022H719.407V247.366Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.407 267.636H704.308V269.292H719.407V267.636Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.165 247.366H705.858V265.154H712.165V247.366Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.238 279.633H705.858V282.941H711.238V279.633Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.238 279.633H708.341V282.941H711.238V279.633Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.651 279.633H712.271V282.941H717.651V279.633Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.856 279.633H714.959V282.941H717.856V279.633Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.03 270.53H705.858V271.771H708.03V270.53Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.134 270.53H708.962V271.771H711.134V270.53Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.855 270.53H712.58V273.013H717.855V270.53Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.752 270.53H712.58V271.771H714.752V270.53Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.856 270.53H715.684V271.771H717.856V270.53Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.165 249.849H705.858V253.987H712.165V249.849Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.165 255.64H705.858V259.778H712.165V255.64Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.165 261.015H705.858V265.153H712.165V261.015Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.064 249.849H710.823V253.987H712.064V249.849Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.064 255.64H710.823V259.778H712.064V255.64Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.064 261.015H710.823V265.153H712.064V261.015Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.407 265.98H704.308V266.395H719.407V265.98Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.855 249.849H715.167V253.987H717.855V249.849Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.855 255.64H715.167V259.778H717.855V255.64Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.855 261.015H715.167V265.153H717.855V261.015Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.856 249.849H717.029V253.987H717.856V249.849Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.856 255.64H717.029V259.778H717.856V255.64Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.856 261.015H717.029V265.153H717.856V261.015Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.099 249.849H707.411V253.987H710.099V249.849Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.099 255.64H707.411V259.778H710.099V255.64Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.099 261.015H707.411V265.153H710.099V261.015Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.922068 283.146H16.24C18.2347 283.146 20.1534 282.389 21.6099 281.028L23.0062 279.723C23.3829 279.368 23.6616 278.922 23.8072 278.425L23.9212 278.035C24.7254 275.313 21.4199 273.27 19.3461 275.205V273.733C19.3461 270.737 15.5846 269.401 13.6944 271.725C14.5968 268.097 10.4301 265.355 7.45706 267.619L6.63069 268.246L6.39955 267.524C5.60168 265.035 2.89776 263.705 0.440803 264.595C-2.00349 265.478 -3.23196 268.208 -2.27894 270.623L-1.84517 271.725C-5.48944 271.725 -7.52847 275.927 -5.27415 278.789L-3.56124 280.967C-2.47841 282.341 -0.82566 283.146 0.925237 283.146H0.922068Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33297 284.155L16.6224 285.684C18.8768 285.909 21.1184 285.152 22.7743 283.604L23.8318 282.616C24.2086 282.262 24.4872 281.815 24.6329 281.318L24.7469 280.929C25.5511 278.206 22.2456 276.164 20.1717 278.098V276.626C20.1717 273.631 16.4103 272.295 14.5201 274.619C15.4225 270.99 11.2558 268.248 8.28273 270.512L7.45636 271.139L6.00308 269.461C4.84743 268.128 2.95405 267.707 1.34564 268.429C-0.0918087 269.075 -1.01633 270.503 -1.01633 272.079V274.619C-4.07486 274.619 -5.68011 278.247 -3.62843 280.511L-1.72872 282.607C-0.934009 283.484 0.158317 284.032 1.33297 284.152V284.155Z",
    fill: "#6F9392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70878 282.94L1.98535 269.287",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60331 271.564L4.87988 279.423",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.53223 277.77L4.67348 279.631",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.625 283.146H472.943C474.931 283.146 476.853 282.389 478.309 281.028L479.709 279.723C480.086 279.368 480.361 278.922 480.507 278.425L480.624 278.035C481.425 275.313 478.123 273.27 476.049 275.205V273.733C476.049 270.737 472.284 269.401 470.397 271.725C471.3 268.097 467.133 265.355 464.16 267.619L463.333 268.246L463.102 267.524C462.304 265.035 459.604 263.705 457.14 264.595C454.699 265.478 453.468 268.208 454.424 270.623L454.858 271.725C451.213 271.725 449.177 275.927 451.429 278.789L453.145 280.967C454.224 282.341 455.88 283.146 457.628 283.146H457.625Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.979 283.145H472.107C474 283.145 475.83 282.457 477.258 281.213L478.376 280.238C478.727 279.931 478.987 279.532 479.13 279.085C479.902 276.641 476.983 274.697 475.045 276.382V275.346C475.045 272.63 471.673 271.369 469.891 273.418C470.73 270.274 467.174 267.808 464.521 269.691L463.451 270.454L463.251 269.878C462.507 267.709 460.151 266.551 457.979 267.285C455.684 268.061 454.535 270.622 455.478 272.851L455.719 273.421C452.477 273.421 450.713 277.211 452.806 279.69L454.262 281.419C455.184 282.514 456.545 283.148 457.983 283.148L457.979 283.145Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.557 282.142C424.557 280.375 424.921 278.631 425.624 277.013L426.33 275.392C427.698 272.244 432.168 272.244 433.536 275.392L434.242 277.013C434.945 278.631 435.309 280.375 435.309 282.142C435.309 282.582 434.955 282.94 434.511 282.94H425.352C424.908 282.94 424.554 282.582 424.554 282.142H424.557Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.007 281.94C426.007 280.499 426.308 279.074 426.893 277.757L427.229 277.004C428.511 274.116 432.608 274.116 433.891 277.004L434.226 277.757C434.809 279.074 435.113 280.499 435.113 281.94C435.113 282.377 434.758 282.734 434.318 282.734H426.805C426.365 282.734 426.01 282.38 426.01 281.94H426.007Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.935 279.837V283.146",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.623 279.011L429.935 281.493",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.868 280.251L429.936 282.527",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.818 283.145H443.082C444.145 283.145 445.165 282.742 445.944 282.017L446.501 281.495C446.688 281.324 446.821 281.109 446.89 280.868L446.944 280.691C447.334 279.377 445.741 278.386 444.734 279.32V278.617C444.734 277.17 442.914 276.521 441.999 277.645C442.436 275.897 440.431 274.571 438.991 275.66L438.582 275.97L438.475 275.625C438.085 274.425 436.784 273.782 435.597 274.21C434.413 274.637 433.817 275.957 434.283 277.126L434.489 277.645C432.731 277.645 431.747 279.674 432.839 281.055L433.662 282.1C434.185 282.758 434.976 283.145 435.818 283.145Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.21 282.94L435.728 279.011",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.383 281.284L438.83 278.181",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.727 283.145L443.794 280.457",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.518 279.837L442.965 281.284",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.277 282.94L436.139 276.113",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.514 283.148H868.832C870.821 283.148 872.743 282.391 874.199 281.029L875.598 279.725C875.975 279.37 876.251 278.924 876.396 278.427L876.514 278.037C877.315 275.315 874.012 273.272 871.938 275.207V273.735C871.938 270.739 868.174 269.403 866.287 271.727C867.189 268.099 863.022 265.357 860.049 267.621L859.223 268.248L858.992 267.526C858.194 265.037 855.493 263.707 853.03 264.597C850.589 265.48 849.357 268.21 850.313 270.625L850.747 271.727C847.103 271.727 845.067 275.929 847.318 278.791L849.034 280.969C850.114 282.343 851.77 283.148 853.518 283.148H853.514Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.868 283.147H867.996C869.889 283.147 871.719 282.46 873.147 281.216L874.265 280.241C874.616 279.934 874.876 279.535 875.018 279.088C875.791 276.644 872.872 274.7 870.934 276.384V275.349C870.934 272.633 867.562 271.372 865.779 273.421C866.618 270.277 863.063 267.81 860.409 269.694L859.339 270.457L859.14 269.881C858.396 267.712 856.04 266.553 853.868 267.288C851.573 268.064 850.423 270.625 851.367 272.854L851.608 273.424C848.365 273.424 846.602 277.214 848.695 279.693L850.151 281.422C851.072 282.517 852.434 283.151 853.871 283.151L853.868 283.147Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.815 282.735L867.195 275.082",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.298 279.423L871.745 278.597",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.678 273.221L865.745 277.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.472 280.459L861.404 277.562",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.32 295.973H-19.1104V300.111H1337.32V295.973Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.97 272.601H289.285V282.941H309.97V272.601Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.97 278.803H289.285V282.941H309.97V278.803Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.829 280.516H292.177V282.941H293.829V280.516Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.186 280.516H295.533V282.941H297.186V280.516Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.057 280.516H299.404V282.941H301.057V280.516Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.414 280.516H302.761V282.941H304.414V280.516Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.029 280.516H306.376V282.941H308.029V280.516Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.829 273.803H292.177V277.52H293.829V273.803Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.186 273.803H295.533V277.52H297.186V273.803Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.057 273.803H299.404V277.52H301.057V273.803Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.414 273.803H302.761V277.52H304.414V273.803Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.029 273.803H306.376V277.52H308.029V273.803Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.711 267.325L289.899 272.597H309.365L299.711 267.325Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.87 273.221L287.835 272.515L299.841 266.188L311.458 272.515L310.587 273.43L299.626 267.43L288.87 273.221Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.541 272.602H717.856V282.942H738.541V272.602Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.541 278.804H717.856V282.942H738.541V278.804Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.401 280.517H720.748V282.942H722.401V280.517Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.755 280.517H724.103V282.942H725.755V280.517Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.626 280.517H727.974V282.942H729.626V280.517Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.982 280.517H731.329V282.942H732.982V280.517Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.596 280.517H734.943V282.942H736.596V280.517Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.401 273.803H720.748V277.52H722.401V273.803Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.755 273.803H724.103V277.52H725.755V273.803Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.626 273.803H727.974V277.52H729.626V273.803Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.982 273.803H731.329V277.52H732.982V273.803Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.596 273.803H734.943V277.52H736.596V273.803Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.286 267.325L718.474 272.597H737.936L728.286 267.325Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.442 273.222L716.406 272.515L728.412 266.189L740.032 272.515L739.158 273.431L728.197 267.431L717.442 273.222Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.35 272.602H1032.67V282.942H1053.35V272.602Z",
    fill: "#F8E7C3",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.35 278.804H1032.67V282.942H1053.35V278.804Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.21 280.517H1035.56V282.942H1037.21V280.517Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.57 280.517H1038.91V282.942H1040.57V280.517Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.43 280.517H1042.78V282.942H1044.43V280.517Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.79 280.517H1046.14V282.942H1047.79V280.517Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.41 280.517H1049.75V282.942H1051.41V280.517Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.21 273.803H1035.56V277.52H1037.21V273.803Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.57 273.803H1038.91V277.52H1040.57V273.803Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.43 273.803H1042.78V277.52H1044.43V273.803Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.79 273.803H1046.14V277.52H1047.79V273.803Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.41 273.803H1049.75V277.52H1051.41V273.803Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.09 267.326L1033.28 272.598H1052.74L1043.09 267.326Z",
    fill: "#F8E7C3",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.25 273.222L1031.22 272.515L1043.22 266.189L1054.84 272.515L1053.97 273.431L1043.01 267.431L1032.25 273.222Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.204 274.873C356.794 274.873 374.297 257.37 374.297 235.78C374.297 214.19 356.794 196.688 335.204 196.688C313.614 196.688 296.111 214.19 296.111 235.78C296.111 257.37 313.614 274.873 335.204 274.873ZM335.204 271.564C354.967 271.564 370.988 255.544 370.988 235.78C370.988 216.017 354.967 199.996 335.204 199.996C315.441 199.996 299.42 216.017 299.42 235.78C299.42 255.544 315.441 271.564 335.204 271.564Z",
    fill: "#EBC7B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.205 256.672C346.742 256.672 356.095 247.411 356.095 235.987C356.095 224.564 346.742 215.303 335.205 215.303C323.667 215.303 314.314 224.564 314.314 235.987C314.314 247.411 323.667 256.672 335.205 256.672ZM335.205 253.778C345.144 253.778 353.201 245.815 353.201 235.991C353.201 226.166 345.144 218.203 335.205 218.203C325.266 218.203 317.208 226.166 317.208 235.991C317.208 245.815 325.266 253.778 335.205 253.778Z",
    fill: "#EBC7B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.204 274.873C356.795 274.873 374.297 257.371 374.297 235.78C374.297 214.19 356.795 196.688 335.204 196.688C313.614 196.688 296.111 214.19 296.111 235.78C296.111 257.371 313.614 274.873 335.204 274.873Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.617 271.564V274.873",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.377 270.945L327.757 274.048",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.205 271.565C354.968 271.565 370.989 255.544 370.989 235.781C370.989 216.018 354.968 199.997 335.205 199.997C315.442 199.997 299.421 216.018 299.421 235.781C299.421 255.544 315.442 271.565 335.205 271.565Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.206 267.43C352.683 267.43 366.851 253.354 366.851 235.99C366.851 218.626 352.683 204.55 335.206 204.55C317.728 204.55 303.56 218.626 303.56 235.99C303.56 253.354 317.728 267.43 335.206 267.43Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.205 263.292C350.169 263.292 362.301 251.069 362.301 235.99C362.301 220.912 350.169 208.688 335.205 208.688C320.24 208.688 308.108 220.912 308.108 235.99C308.108 251.069 320.24 263.292 335.205 263.292Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.204 259.984C348.342 259.984 358.992 249.241 358.992 235.99C358.992 222.739 348.342 211.997 335.204 211.997C322.067 211.997 311.417 222.739 311.417 235.99C311.417 249.241 322.067 259.984 335.204 259.984Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.205 256.676C346.742 256.676 356.095 247.415 356.095 235.991C356.095 224.567 346.742 215.307 335.205 215.307C323.667 215.307 314.314 224.567 314.314 235.991C314.314 247.415 323.667 256.676 335.205 256.676Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.206 253.778C345.145 253.778 353.202 245.815 353.202 235.991C353.202 226.167 345.145 218.203 335.206 218.203C325.266 218.203 317.209 226.167 317.209 235.991C317.209 245.815 325.266 253.778 335.206 253.778Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.204 247.161C341.487 247.161 346.58 242.16 346.58 235.991C346.58 229.821 341.487 224.82 335.204 224.82C328.921 224.82 323.828 229.821 323.828 235.991C323.828 242.16 328.921 247.161 335.204 247.161Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.404 277.562H357.337C356.839 276.735 357.131 275.7 357.337 275.285H359.404C359.901 276.279 359.61 277.217 359.404 277.562Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.889 280.045H347.822C347.325 279.219 347.616 278.183 347.822 277.769H349.889C350.387 278.763 350.095 279.7 349.889 280.045Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.201 281.7H339.133C338.636 280.874 338.928 279.839 339.133 279.424H341.201C341.698 280.418 341.407 281.355 341.201 281.7Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.102 281.7H330.035C329.538 280.874 329.829 279.839 330.035 279.424H332.102C332.599 280.418 332.308 281.355 332.102 281.7Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.829 280.459H321.761C321.264 279.633 321.556 278.597 321.761 278.183H323.829C324.326 279.177 324.035 280.114 323.829 280.459Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.851 272.186H364.784C364.287 271.359 364.578 270.324 364.784 269.909H366.851C367.348 270.903 367.057 271.841 366.851 272.186Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.468 264.739H371.4C370.903 263.913 371.194 262.878 371.4 262.463H373.468C373.965 263.457 373.673 264.394 373.468 264.739Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.021 256.466H375.954C375.457 255.64 375.748 254.604 375.954 254.189H378.021C378.518 255.184 378.227 256.121 378.021 256.466Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.329 247.366H379.261C378.764 246.54 379.056 245.505 379.261 245.09H381.329C381.826 246.084 381.535 247.021 381.329 247.366Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.155 237.852H380.088C379.59 237.025 379.882 235.99 380.088 235.575H382.155C382.652 236.569 382.361 237.507 382.155 237.852Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.916 228.334H378.848C378.351 227.508 378.642 226.472 378.848 226.058H380.916C381.413 227.052 381.122 227.989 380.916 228.334Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.606 219.234H375.539C375.042 218.408 375.333 217.373 375.539 216.958H377.606C378.103 217.952 377.812 218.889 377.606 219.234Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.056 210.547H370.989C370.492 209.721 370.783 208.685 370.989 208.271H373.056C373.554 209.265 373.262 210.202 373.056 210.547Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.435 203.93H364.368C363.871 203.103 364.162 202.068 364.368 201.653H366.435C366.932 202.648 366.641 203.585 366.435 203.93Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.578 198.139H356.51C356.013 197.312 356.305 196.277 356.51 195.862H358.578C359.075 196.856 358.784 197.794 358.578 198.139Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.889 194.826H347.822C347.325 194 347.616 192.965 347.822 192.55H349.889C350.387 193.544 350.095 194.481 349.889 194.826Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.375 192.759H338.307C337.81 191.933 338.101 190.897 338.307 190.482H340.375C340.872 191.477 340.581 192.414 340.375 192.759Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.861 193.174H328.794C328.297 192.348 328.588 191.312 328.794 190.897H330.861C331.358 191.892 331.067 192.829 330.861 193.174Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.346 195.241H319.279C318.782 194.415 319.073 193.38 319.279 192.965H321.346C321.844 193.959 321.552 194.896 321.346 195.241Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.074 198.964H311.007C310.509 198.138 310.801 197.102 311.007 196.688H313.074C313.571 197.682 313.28 198.619 313.074 198.964Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.212 204.756H303.144C302.647 203.93 302.938 202.894 303.144 202.479H305.212C305.709 203.474 305.417 204.411 305.212 204.756Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.006 211.788H296.938C296.441 210.962 296.732 209.926 296.938 209.512H299.006C299.503 210.506 299.211 211.443 299.006 211.788Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.044 220.476H291.976C291.479 219.649 291.77 218.614 291.976 218.199H294.044C294.541 219.193 294.25 220.131 294.044 220.476Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.562 229.164H289.495C288.998 228.338 289.289 227.302 289.495 226.888H291.562C292.059 227.882 291.768 228.819 291.562 229.164Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.732 238.679H288.665C288.168 237.852 288.459 236.817 288.665 236.402H290.732C291.229 237.397 290.938 238.334 290.732 238.679Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.562 248.192H289.495C288.998 247.366 289.289 246.331 289.495 245.916H291.562C292.059 246.91 291.768 247.847 291.562 248.192Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.456 257.292H292.388C291.891 256.466 292.183 255.43 292.388 255.016H294.456C294.953 256.01 294.662 256.947 294.456 257.292Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.421 265.566H297.353C296.856 264.739 297.147 263.704 297.353 263.289H299.421C299.918 264.283 299.627 265.22 299.421 265.566Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.042 272.601H303.974C303.477 271.774 303.768 270.739 303.974 270.324H306.042C306.539 271.318 306.248 272.256 306.042 272.601Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.899 277.978H311.832C311.335 277.151 311.626 276.116 311.832 275.701H313.899C314.396 276.695 314.105 277.633 313.899 277.978Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.215 210.757L334.79 235.785",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.626 203.929L334.79 235.78",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.073 198.759L334.79 235.575",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.347 195.242L334.999 235.576",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.239 193.174L334.998 235.575",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.133 192.758L335.204 234.953",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.027 194.826L335.204 235.575",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.509 198.138L335.204 235.784",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.162 203.1L335.204 235.781",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.779 209.515L335.204 235.784",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.331 217.373L335.617 235.781",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.847 226.061L335.41 235.781",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.915 235.575L334.996 235.99",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.088 245.09L335.619 235.99",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.985 253.984L335.204 235.987",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.436 262.465L334.999 235.783",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.025 269.91L335.414 235.987",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.369 275.289L334.996 235.781",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.063 277.562L334.999 235.781",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.25 218.408L334.999 235.99",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.769 227.302L334.791 235.99",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.941 236.61L335.205 235.783",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.562 245.916L334.998 235.987",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.629 255.018L335.619 235.783",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.386 263.292L334.79 235.99",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.006 270.324L335.411 235.575",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.864 275.7L335.202 235.572",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.172 278.182L335.204 235.366",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.066 279.424L335.205 235.575",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.375 279.218L334.996 235.575",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.695 207.238L311.833 204.55",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.108 212.202L305.626 210.34",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.971 218.408L301.283 216.752",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.867 225.236L297.765 224.409",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.42 232.886L296.523 232.472",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.626 240.331L296.523 240.746",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.283 247.572L298.386 248.813",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.591 254.189L301.903 255.845",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.935 260.189L306.658 262.466",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.726 265.153L312.864 267.841",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.311 203.1L318.864 200.412",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.343 200.826L326.517 197.724",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.789 196.688V199.996",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.064 197.519L342.443 200.621",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.924 200L349.478 202.897",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.957 204.136L356.096 206.618",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.954 209.306L361.472 211.582",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.918 216.132L366.229 217.579",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.227 223.373L369.33 224.408",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.088 231.438L370.779 231.852",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.088 239.71L370.985 239.295",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.642 247.366L369.539 246.54",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.127 254.809L366.438 253.153",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.368 261.429L362.092 259.567",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.369 267.015L356.507 264.533",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.131 271.15L349.89 268.462",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.684 270.739L344.51 273.636",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.279 197.103L321.758 198.964",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.967 201.652L319.484 195.035",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.553 193.174L329.62 197.103",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.828 198.344L328.587 192.553",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.275 191.724L337.481 196.688",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.896 196.897L338.102 191.727",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.752 198.14L340.787 192.14",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.169 196.896L347.616 192.758",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.095 194.416L353.612 201.242",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.028 198.759L356.096 196.897",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.368 198.138L360.23 205.79",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.475 202.068L364.368 201.653",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.092 207.444L370.986 208.271",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.815 211.376V203.929",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.472 213.65L376.366 216.753",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.365 218.614L371.401 210.547",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.194 220.271L379.882 226.061",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.262 226.476L376.159 219.238",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.469 227.923L380.707 235.576",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.848 228.129L374.298 234.54",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.298 236.816L380.089 244.884",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.677 242.813L379.882 237.228",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.469 244.675L376.986 253.983",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.4 250.469L379.053 245.71",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.779 252.328L372.435 262.257",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.677 257.707L375.744 255.019",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.435 259.362L366.229 269.703",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.4 262.671L362.092 264.118",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.851 265.358L358.783 275.288",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.889 268.877L364.782 269.912",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.336 275.288L347.616 273.221",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.233 269.703L350.095 277.976",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.829 273.221L313.899 275.703",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.175 270.118L321.76 277.977",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.765 259.155L294.665 255.638",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.041 252.947L298.18 263.082",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.626 252.122L291.974 246.951",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.354 245.505L293.836 255.019",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.111 235.576L291.562 229.164",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.733 229.164L289.906 236.402",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.937 227.303L294.04 220.271",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.595 221.512L291.769 226.891",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.627 219.442L298.386 211.789",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.728 214.064L294.04 218.203",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.766 212.409V204.756",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.694 207.859L298.8 209.306",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.314 202.688H305.42",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.555 206.203L311.002 198.965",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.938 243.849L290.938 238.058",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.111 237.438L290.526 245.917",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.385 260.189V270.119",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.729 264.533L299.421 263.292",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.346 269.499L306.037 270.325",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.177 265.774L312.865 275.704",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.486 283.147L334.376 235.366L335.202 238.054L317 283.144H313.482L313.486 283.147Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.68 283.977L335.825 234.543L334.999 237.231L352.787 283.977H355.684H355.68Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.996 239.713C337.052 239.713 338.719 238.046 338.719 235.99C338.719 233.934 337.052 232.267 334.996 232.267C332.939 232.267 331.272 233.934 331.272 235.99C331.272 238.046 332.939 239.713 334.996 239.713Z",
    fill: "#E8E1F3",
    stroke: "#E8E1F3",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.655 273.428L330.035 279.219",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.446 274.668L324.034 278.391",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.137 274.873L338.928 279.423",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.929 274.873L332.103 279.632",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.996 274.463L347.613 277.981",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.166 273.428L341.407 279.428",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.105 290.18L803.036 292.285C806.379 292.656 809.583 290.864 811.014 287.821L811.948 285.839C812.262 285.174 812.404 284.443 812.366 283.711L812.262 281.742C812.05 277.635 806.49 276.54 804.736 280.257L803.764 277.1C802.497 272.981 796.678 272.956 795.373 277.065C794.848 271.205 787.141 269.425 784.102 274.463L783.31 273.212C781.151 269.796 776.471 269.074 773.378 271.677C770.718 273.918 770.231 277.832 772.257 280.659L774.318 283.531C771.462 284.408 771.811 288.552 774.768 288.942L784.102 290.177L784.105 290.18Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.854 290.179L801.749 292.209C805.074 292.607 808.291 290.853 809.753 287.839L810.406 286.494C810.703 285.883 810.846 285.208 810.811 284.531L810.735 282.922C810.561 279.145 805.463 278.094 803.81 281.491L802.965 278.749C801.803 274.956 796.452 274.902 795.214 278.67C794.765 273.344 787.783 271.67 784.962 276.21L784.851 276.393L784.152 275.301C782.163 272.201 777.914 271.54 775.074 273.886C772.579 275.95 772.12 279.604 774.026 282.222L775.783 284.635C773.298 285.398 773.652 289.023 776.239 289.289L784.848 290.176L784.854 290.179Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.056 290.506L747.773 286.143C745.085 284.727 743.454 281.894 743.578 278.861L743.698 276.024C743.727 275.289 743.939 274.577 744.316 273.943L745.316 272.246C747.409 268.707 752.842 270.309 752.674 274.418L754.995 272.072C758.028 269.007 763.199 271.683 762.448 275.929C765.624 270.977 773.283 272.971 773.644 278.845L774.923 278.104C778.422 276.077 782.902 277.604 784.437 281.343C785.758 284.563 784.374 288.258 781.268 289.822L778.115 291.414H759.719C758.44 291.414 757.183 291.104 756.053 290.509L756.056 290.506Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.273 289.015L747.597 286.862C745.679 285.32 744.593 282.967 744.666 280.507L744.761 277.322C744.776 276.644 744.966 275.983 745.311 275.397L746.122 274.007C748.025 270.743 753.027 272.167 752.923 275.945L754.937 273.906C757.726 271.085 762.491 273.513 761.845 277.43C764.711 272.918 771.673 274.666 772.069 279.997L772.085 280.213L773.215 279.57C776.41 277.743 780.485 279.127 781.909 282.521C783.163 285.507 781.881 288.955 778.977 290.395L776.302 291.719H761.848L754.158 290.686C752.739 290.496 751.394 289.92 750.276 289.021L750.273 289.015Z",
    fill: "#7CC69A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.533 277.343C719.948 275.855 720.23 273.62 719.226 271.828L713.533 261.636C712.979 260.645 711.554 260.645 711 261.636L705.143 272.129C704.228 273.762 704.427 275.795 705.64 277.223C706.492 278.227 707.742 278.803 709.063 278.803H715.132C716.418 278.803 717.646 278.274 718.533 277.343Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.192 277.553C719.556 276.28 719.825 274.216 718.834 272.636L714.085 265.104C713.439 264.075 711.935 264.075 711.289 265.104L705.866 273.709C705.258 274.678 705.385 275.938 706.176 276.768C707.3 277.939 708.851 278.601 710.476 278.601H715.545C716.529 278.601 717.476 278.228 718.198 277.556L718.192 277.553Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.271 268.257V283.562",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.168 269.499L712.065 272.396",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.374 272.805L712.477 275.702",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.959 269.499L712.062 272.396",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.94 283.328C729.865 281.596 729.59 278.506 727.396 277.138L723.752 274.871C723.188 274.523 722.472 274.536 721.928 274.909L718.692 277.116C716.599 278.547 716.321 281.526 718.113 283.319C718.138 283.341 718.166 283.353 718.198 283.353H727.871C727.896 283.353 727.921 283.344 727.94 283.325V283.328Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.94 283.325C727.921 283.344 727.896 283.353 727.871 283.353H718.198C718.166 283.353 718.138 283.341 718.113 283.319C716.321 281.526 716.599 278.547 718.692 277.116L721.928 274.909C722.472 274.536 723.188 274.523 723.752 274.871L727.396 277.138C729.59 278.506 729.865 281.596 727.94 283.328V283.325ZM727.94 283.325L728.08 283.48",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.478 283.062C729.735 281.552 729.33 279.272 727.63 278.284L723.552 275.919C723.102 275.659 722.542 275.666 722.098 275.935L719.303 277.641C717.314 278.854 717.172 281.688 719.03 283.094C719.072 283.128 719.125 283.144 719.182 283.144H728.288C728.364 283.144 728.428 283.113 728.478 283.056V283.062Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.439 279.839V283.148",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.752 279.012L723.44 281.494",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.507 280.253L723.439 282.529",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.609 236.61H846.51V244.057H855.609V236.61Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.438 238.567V244.054H846.506V236.842L844.438 238.564V238.567Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.918 246.535H731.919V249.017H858.918V246.535Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.418 252.741L730 250.259H861.621L859.845 252.741H731.418Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.159 252.741H731.507V282.94H745.159V252.741Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.159 252.741H731.507V255.638H745.159V252.741Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.747 252.741H846.095V255.638H859.747V252.741Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.26 272.187H734.401V282.942H742.26V272.187Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.504 269.702H733.575V270.529H743.504V269.702Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.335 272.185L733.673 270.529H743.346L742.351 272.185H734.335Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.191 273.841H736.883V282.94H740.191V273.841Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.021 264.323H736.057V265.979H741.021V264.323Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.366 274.667H737.71V278.805H739.366V274.667Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.747 252.741H846.095V282.94H859.747V252.741Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.094 252.741H745.156V255.223H846.094V252.741Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.094 255.224H745.156V258.532H846.094V255.224Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.121 258.533H745.156V282.941H750.121V258.533Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.774 258.533H758.81V282.941H763.774V258.533Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.664 258.533H773.699V282.941H778.664V258.533Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.731 258.533H787.767V282.941H792.731V258.533Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.728 258.533H799.764V282.941H804.728V258.533Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.204 258.533H813.413V282.941H819.204V258.533Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.683 258.533H826.651V282.941H833.683V258.533Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.095 258.533H839.062V282.941H846.095V258.533Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.053 255.224H745.156V256.465H748.053V255.224Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.639 256.464H745.156V282.939H747.639V256.464Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.097 255.224H843.2V256.465H846.097V255.224Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.094 256.464H843.611V282.939H846.094V256.464Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.702 255.224H758.394V256.465H761.702V255.224Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.292 256.464H758.81V282.939H761.292V256.464Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.597 255.224H773.288V256.465H776.597V255.224Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.181 256.464H773.699V282.939H776.181V256.464Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.661 255.224H787.353V256.465H790.661V255.224Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.249 256.464H787.767V282.939H790.249V256.464Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.14 255.224H801.831V256.465H805.14V255.224Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.727 256.464H802.245V282.939H804.727V256.464Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.618 255.224H816.31V256.465H819.618V255.224Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.207 256.464H816.725V282.939H819.207V256.464Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.098 255.224H830.789V256.465H834.098V255.224Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.686 256.464H831.204V282.939H833.686V256.464Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.818 245.294L730.887 244.053H860.782L859.852 245.294H731.818Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.818 246.536L730.887 245.295H860.782L859.852 246.536H731.818Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.785 250.259L728.825 249.018H862.84L861.881 250.259H729.785Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.539 263.501C740.139 263.501 741.436 262.204 741.436 260.604C741.436 259.004 740.139 257.707 738.539 257.707C736.939 257.707 735.642 259.004 735.642 260.604C735.642 262.204 736.939 263.501 738.539 263.501Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.54 262.67C739.682 262.67 740.608 261.745 740.608 260.603C740.608 259.461 739.682 258.535 738.54 258.535C737.398 258.535 736.473 259.461 736.473 260.603C736.473 261.745 737.398 262.67 738.54 262.67Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.9 237.437L794.177 239.092L797.28 244.057C796.523 244.057 794.756 244.016 793.762 243.851C791.777 242.692 791.97 239.922 792.315 238.681L791.9 237.44V237.437Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.249 238.262L792.526 239.709L795.628 244.053C794.872 244.053 793.105 244.018 792.111 243.872C790.126 242.859 790.319 240.434 790.664 239.348L790.249 238.262Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.593 238.678L790.869 240.023L793.972 244.057C793.215 244.057 791.449 244.022 790.455 243.889C788.469 242.949 788.662 240.695 789.008 239.688L788.593 238.678Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.525 239.504L788.802 240.641L791.905 244.054C791.148 244.054 789.381 244.025 788.387 243.911C786.402 243.113 786.595 241.21 786.94 240.356L786.525 239.504Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.284 241.161L787.561 241.886L790.664 244.058C789.907 244.058 788.14 244.039 787.146 243.966C785.161 243.46 785.354 242.247 785.699 241.703L785.284 241.161Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.416 237.437L799.14 239.092L796.037 244.057C796.794 244.057 798.561 244.016 799.555 243.851C801.54 242.692 801.347 239.922 801.002 238.681L801.416 237.44V237.437Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.072 238.262L800.795 239.709L797.692 244.053C798.449 244.053 800.216 244.018 801.21 243.872C803.195 242.859 803.002 240.434 802.657 239.348L803.072 238.262Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.727 238.678L802.45 240.023L799.348 244.057C800.104 244.057 801.871 244.022 802.865 243.889C804.85 242.949 804.657 240.695 804.312 239.688L804.727 238.678Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.795 239.504L804.519 240.641L801.416 244.054C802.173 244.054 803.939 244.025 804.934 243.911C806.919 243.113 806.726 241.21 806.381 240.356L806.795 239.504Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.036 241.161L805.759 241.886L802.656 244.058C803.413 244.058 805.18 244.039 806.174 243.966C808.159 243.46 807.966 242.247 807.621 241.703L808.036 241.161Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.66 243.227C798.144 243.227 799.348 242.023 799.348 240.539C799.348 239.054 798.144 237.851 796.66 237.851C795.175 237.851 793.972 239.054 793.972 240.539C793.972 242.023 795.175 243.227 796.66 243.227Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.66 242.401C797.688 242.401 798.521 241.568 798.521 240.539C798.521 239.511 797.688 238.678 796.66 238.678C795.631 238.678 794.798 239.511 794.798 240.539C794.798 241.568 795.631 242.401 796.66 242.401Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.572 258.811L734.344 258.026C734.268 257.763 734.467 257.497 734.746 257.497H735.772C735.826 257.497 735.876 257.487 735.921 257.468L738.368 256.528C738.476 256.487 738.596 256.493 738.701 256.544L741.268 257.826C741.373 257.88 741.496 257.883 741.607 257.839L742.041 257.665C742.269 257.573 742.525 257.699 742.592 257.934L742.845 258.804C742.87 258.893 742.867 258.988 742.829 259.07L742.551 259.77C742.497 259.897 742.513 260.039 742.589 260.153L742.769 260.426C742.839 260.533 742.855 260.666 742.82 260.786L742.532 261.645C742.494 261.765 742.51 261.898 742.582 262.005L742.753 262.259C742.836 262.382 742.845 262.541 742.779 262.674L742.563 263.101C742.506 263.218 742.506 263.354 742.563 263.471L742.804 263.946C742.858 264.051 742.861 264.174 742.817 264.285L742.557 264.944C742.503 265.07 742.519 265.213 742.595 265.327L742.734 265.536C742.826 265.675 742.826 265.856 742.734 265.995L742.605 266.185C742.522 266.308 742.513 266.467 742.579 266.6L742.795 267.027C742.852 267.144 742.852 267.28 742.795 267.397L742.551 267.882C742.5 267.98 742.51 268.097 742.573 268.186C742.706 268.388 742.56 268.661 742.316 268.661H734.838C734.699 268.661 734.569 268.591 734.49 268.477L734.331 268.24C734.249 268.116 734.239 267.958 734.306 267.825L734.521 267.397C734.578 267.28 734.578 267.144 734.521 267.027L734.306 266.6C734.239 266.467 734.249 266.308 734.331 266.185L734.461 265.995C734.553 265.856 734.553 265.675 734.461 265.536L734.322 265.327C734.246 265.213 734.23 265.07 734.284 264.944L734.543 264.285C734.588 264.174 734.585 264.051 734.531 263.946L734.29 263.471C734.233 263.354 734.233 263.218 734.29 263.101L734.521 262.642C734.578 262.525 734.578 262.389 734.521 262.271L734.281 261.797C734.227 261.692 734.224 261.569 734.268 261.458L734.528 260.799C734.581 260.673 734.566 260.53 734.49 260.416L734.315 260.156C734.239 260.042 734.224 259.9 734.278 259.773L734.556 259.074C734.594 258.988 734.597 258.893 734.572 258.808V258.811Z",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.85 272.187H848.991V282.942H856.85V272.187Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.091 269.702H848.162V270.529H858.091V269.702Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.924 272.185L848.263 270.529H857.935L856.941 272.185H848.924Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.782 273.841H851.474V282.94H854.782V273.841Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.609 264.323H850.645V265.979H855.609V264.323Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.957 274.667H852.301V278.805H853.957V274.667Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.127 263.501C854.727 263.501 856.024 262.204 856.024 260.604C856.024 259.004 854.727 257.707 853.127 257.707C851.527 257.707 850.229 259.004 850.229 260.604C850.229 262.204 851.527 263.501 853.127 263.501Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.125 262.67C854.267 262.67 855.193 261.745 855.193 260.603C855.193 259.461 854.267 258.535 853.125 258.535C851.983 258.535 851.058 259.461 851.058 260.603C851.058 261.745 851.983 262.67 853.125 262.67Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.159 258.811L848.931 258.026C848.855 257.763 849.054 257.497 849.333 257.497H850.359C850.413 257.497 850.463 257.487 850.508 257.468L852.958 256.528C853.066 256.487 853.186 256.493 853.288 256.544L855.855 257.826C855.96 257.88 856.083 257.883 856.194 257.839L856.628 257.665C856.856 257.573 857.112 257.699 857.179 257.934L857.432 258.804C857.457 258.893 857.454 258.988 857.416 259.07L857.138 259.77C857.084 259.897 857.1 260.039 857.176 260.153L857.356 260.426C857.426 260.533 857.442 260.666 857.407 260.786L857.119 261.645C857.081 261.765 857.096 261.898 857.169 262.005L857.34 262.259C857.423 262.382 857.432 262.541 857.366 262.674L857.15 263.101C857.093 263.218 857.093 263.354 857.15 263.471L857.391 263.946C857.445 264.051 857.448 264.174 857.404 264.285L857.144 264.944C857.09 265.07 857.106 265.213 857.182 265.327L857.321 265.536C857.413 265.675 857.413 265.856 857.321 265.995L857.195 266.185C857.112 266.308 857.103 266.467 857.169 266.6L857.385 267.027C857.442 267.144 857.442 267.28 857.385 267.397L857.141 267.882C857.09 267.98 857.1 268.097 857.163 268.186C857.296 268.388 857.15 268.661 856.906 268.661H849.428C849.289 268.661 849.159 268.591 849.08 268.477L848.921 268.24C848.839 268.116 848.83 267.958 848.896 267.825L849.111 267.397C849.168 267.28 849.168 267.144 849.111 267.027L848.896 266.6C848.83 266.467 848.839 266.308 848.921 266.185L849.048 265.995C849.14 265.856 849.14 265.675 849.048 265.536L848.909 265.327C848.833 265.213 848.817 265.07 848.871 264.944L849.13 264.285C849.175 264.174 849.172 264.051 849.118 263.946L848.877 263.471C848.82 263.354 848.82 263.218 848.877 263.101L849.108 262.642C849.165 262.525 849.165 262.389 849.108 262.271L848.868 261.797C848.814 261.692 848.811 261.569 848.855 261.458L849.115 260.799C849.168 260.673 849.153 260.53 849.077 260.416L848.902 260.156C848.826 260.042 848.811 259.9 848.864 259.773L849.143 259.074C849.181 258.988 849.184 258.893 849.159 258.808V258.811Z",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.741 236.61H735.642V244.057H744.741V236.61Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.813 238.567V244.054H744.745V236.842L746.813 238.564V238.567Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.752 239.604L734.543 243.72C734.581 243.916 734.756 244.056 734.952 244.056H779.494C779.722 244.056 779.908 243.869 779.908 243.641V242.545C779.908 242.45 779.877 242.358 779.817 242.286L779.155 241.459C779.104 241.396 779.076 241.32 779.069 241.241L778.879 239.351C778.876 239.313 778.867 239.278 778.854 239.243L778.313 237.837C778.189 237.508 777.705 237.562 777.654 237.913C777.6 238.28 777.087 238.315 776.983 237.957L776.967 237.891C776.863 237.54 776.362 237.549 776.277 237.904L776.157 238.382C776.065 238.749 775.536 238.736 775.46 238.366L775.403 238.068C775.34 237.768 774.915 237.758 774.839 238.056L774.814 238.16C774.744 238.432 774.355 238.423 774.301 238.147C774.247 237.888 773.883 237.859 773.791 238.109L773.601 238.641C773.503 238.907 773.12 238.892 773.047 238.619C772.962 238.312 772.519 238.344 772.477 238.657L772.468 238.708C772.427 239.04 771.955 239.062 771.876 238.736L771.676 237.885C771.6 237.581 771.176 237.559 771.078 237.859L771.002 238.078C770.91 238.35 770.514 238.303 770.489 238.018C770.464 237.736 770.074 237.682 769.979 237.948L769.872 238.236C769.767 238.527 769.356 238.527 769.251 238.236L769.09 237.79C768.982 237.495 768.561 237.517 768.482 237.821L768.437 238.002C768.368 238.293 767.947 238.277 767.896 237.98C767.845 237.692 767.44 237.663 767.355 237.945L767.174 238.543C767.092 238.806 766.715 238.79 766.658 238.524L766.633 238.407C766.582 238.182 766.272 238.16 766.189 238.375C766.104 238.603 765.768 238.559 765.743 238.318V238.28C765.714 238.027 765.363 237.983 765.274 238.223L765.195 238.439C765.091 238.724 764.679 238.683 764.632 238.382L764.594 238.147C764.552 237.866 764.157 237.853 764.09 238.128L764.081 238.163C764.017 238.436 763.625 238.417 763.59 238.141L763.568 237.983C763.53 237.723 763.153 237.717 763.118 237.98C763.077 238.227 762.729 238.242 762.672 238.002L762.615 237.771C762.545 237.489 762.14 237.495 762.076 237.78L762.026 238.008C761.95 238.356 761.456 238.356 761.38 238.008L761.367 237.954C761.291 237.606 760.804 237.59 760.706 237.932L760.63 238.189C760.519 238.578 759.968 238.581 759.848 238.192C759.727 237.796 759.164 237.806 759.056 238.204L759.024 238.331C758.913 238.746 758.321 238.74 758.223 238.318L758.1 237.787C758.021 237.464 757.558 237.47 757.495 237.796L757.47 237.904C757.406 238.22 756.954 238.211 756.903 237.891C756.859 237.597 756.453 237.555 756.349 237.831L756.197 238.227C756.07 238.565 755.573 238.505 755.522 238.147C755.472 237.768 754.934 237.733 754.835 238.103L754.778 238.331C754.68 238.692 754.174 238.714 754.05 238.363L753.993 238.211C753.882 237.907 753.449 237.926 753.363 238.236C753.271 238.569 752.796 238.559 752.717 238.223L752.622 237.802C752.546 237.486 752.119 237.445 751.986 237.742L751.869 237.999C751.774 238.214 751.454 238.182 751.406 237.951C751.349 237.692 750.976 237.698 750.925 237.957L750.84 238.385C750.783 238.673 750.365 238.66 750.327 238.369C750.289 238.078 749.871 238.065 749.814 238.353L749.782 238.512C749.719 238.819 749.282 238.819 749.219 238.512L749.187 238.353C749.124 238.033 748.665 238.04 748.608 238.36C748.551 238.692 748.066 238.667 748.025 238.331C747.987 238.011 747.534 237.967 747.449 238.28C747.373 238.55 747.002 238.575 746.895 238.318L746.882 238.29C746.774 238.046 746.426 238.043 746.318 238.287L746.084 238.822C745.951 239.119 745.543 239.154 745.359 238.882L744.818 238.068C744.694 237.882 744.412 237.897 744.308 238.1C744.184 238.353 743.808 238.299 743.757 238.021L743.747 237.967C743.684 237.641 743.225 237.619 743.136 237.942L743.121 238.011C743.038 238.309 742.633 238.341 742.503 238.062L742.171 237.331C742.06 237.09 741.708 237.118 741.636 237.372L741.531 237.749C741.468 237.976 741.135 237.948 741.113 237.711C741.091 237.476 740.765 237.445 740.695 237.669L740.638 237.872C740.562 238.113 740.223 238.113 740.151 237.872L740.097 237.692C740.005 237.391 739.574 237.4 739.502 237.704L739.464 237.847C739.394 238.138 738.976 238.122 738.922 237.828C738.872 237.549 738.488 237.517 738.387 237.783L738.292 238.046C738.175 238.369 737.71 238.35 737.618 238.018L737.561 237.809C737.482 237.511 737.064 237.502 736.966 237.793C736.874 238.078 736.468 238.078 736.377 237.793L736.361 237.749C736.263 237.451 735.838 237.451 735.74 237.749L735.595 238.185C735.525 238.398 735.243 238.448 735.107 238.274C734.936 238.065 734.604 238.182 734.604 238.451V239.249C734.604 239.477 734.319 239.579 734.173 239.404C734.011 239.211 733.701 239.36 733.745 239.607L733.752 239.604Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.914 239.604L857.123 243.72C857.085 243.916 856.911 244.056 856.714 244.056H812.173C811.945 244.056 811.758 243.869 811.758 243.641V242.545C811.758 242.45 811.789 242.358 811.85 242.286L812.511 241.459C812.562 241.396 812.59 241.32 812.597 241.241L812.787 239.351C812.79 239.313 812.799 239.278 812.812 239.243L813.354 237.837C813.477 237.508 813.961 237.562 814.012 237.913C814.066 238.28 814.579 238.315 814.683 237.957L814.699 237.891C814.804 237.54 815.304 237.549 815.389 237.904L815.51 238.382C815.602 238.749 816.13 238.736 816.206 238.366L816.263 238.068C816.327 237.768 816.751 237.758 816.827 238.056L816.852 238.16C816.922 238.432 817.311 238.423 817.365 238.147C817.419 237.888 817.783 237.859 817.875 238.109L818.065 238.641C818.163 238.907 818.546 238.892 818.619 238.619C818.704 238.312 819.148 238.344 819.189 238.657L819.198 238.708C819.239 239.04 819.711 239.062 819.79 238.736L819.99 237.885C820.066 237.581 820.49 237.559 820.588 237.859L820.664 238.078C820.756 238.35 821.152 238.303 821.177 238.018C821.203 237.736 821.592 237.682 821.687 237.948L821.795 238.236C821.899 238.527 822.311 238.527 822.415 238.236L822.577 237.79C822.684 237.495 823.105 237.517 823.185 237.821L823.229 238.002C823.299 238.293 823.72 238.277 823.77 237.98C823.821 237.692 824.226 237.663 824.312 237.945L824.492 238.543C824.574 238.806 824.951 238.79 825.008 238.524L825.034 238.407C825.084 238.182 825.394 238.16 825.477 238.375C825.562 238.603 825.898 238.559 825.923 238.318V238.28C825.952 238.027 826.303 237.983 826.392 238.223L826.471 238.439C826.576 238.724 826.987 238.683 827.035 238.382L827.073 238.147C827.114 237.866 827.51 237.853 827.576 238.128L827.586 238.163C827.649 238.436 828.041 238.417 828.076 238.141L828.098 237.983C828.136 237.723 828.513 237.717 828.548 237.98C828.589 238.227 828.937 238.242 828.994 238.002L829.051 237.771C829.121 237.489 829.526 237.495 829.59 237.78L829.64 238.008C829.716 238.356 830.21 238.356 830.286 238.008L830.299 237.954C830.375 237.606 830.863 237.59 830.961 237.932L831.037 238.189C831.147 238.578 831.698 238.581 831.819 238.192C831.939 237.796 832.503 237.806 832.61 238.204L832.642 238.331C832.753 238.746 833.345 238.74 833.443 238.318L833.566 237.787C833.646 237.464 834.108 237.47 834.171 237.796L834.196 237.904C834.26 238.22 834.713 238.211 834.763 237.891C834.808 237.597 835.213 237.555 835.317 237.831L835.469 238.227C835.599 238.565 836.093 238.505 836.144 238.147C836.194 237.768 836.733 237.733 836.831 238.103L836.888 238.331C836.986 238.692 837.492 238.714 837.616 238.363L837.673 238.211C837.784 237.907 838.218 237.926 838.303 238.236C838.395 238.569 838.87 238.559 838.949 238.223L839.044 237.802C839.12 237.486 839.547 237.445 839.68 237.742L839.798 237.999C839.892 238.214 840.212 238.182 840.26 237.951C840.317 237.692 840.69 237.698 840.741 237.957L840.827 238.385C840.884 238.673 841.301 238.66 841.339 238.369C841.377 238.078 841.795 238.065 841.852 238.353L841.884 238.512C841.947 238.819 842.384 238.819 842.448 238.512L842.479 238.353C842.543 238.033 843.002 238.04 843.059 238.36C843.116 238.692 843.6 238.667 843.641 238.331C843.679 238.011 844.132 237.967 844.217 238.28C844.293 238.55 844.664 238.575 844.772 238.318L844.784 238.29C844.892 238.046 845.24 238.043 845.348 238.287L845.582 238.822C845.715 239.119 846.123 239.154 846.307 238.882L846.849 238.068C846.972 237.882 847.254 237.897 847.358 238.1C847.482 238.353 847.859 238.299 847.909 238.021L847.919 237.967C847.982 237.641 848.441 237.619 848.53 237.942L848.546 238.011C848.628 238.309 849.033 238.341 849.163 238.062L849.495 237.331C849.606 237.09 849.958 237.118 850.031 237.372L850.135 237.749C850.198 237.976 850.531 237.948 850.553 237.711C850.575 237.476 850.901 237.445 850.971 237.669L851.028 237.872C851.104 238.113 851.443 238.113 851.515 237.872L851.569 237.692C851.661 237.391 852.092 237.4 852.165 237.704L852.203 237.847C852.272 238.138 852.69 238.122 852.744 237.828C852.795 237.549 853.178 237.517 853.279 237.783L853.374 238.046C853.491 238.369 853.957 238.35 854.048 238.018L854.105 237.809C854.185 237.511 854.603 237.502 854.701 237.793C854.792 238.078 855.198 238.078 855.29 237.793L855.305 237.749C855.404 237.451 855.828 237.451 855.926 237.749L856.072 238.185C856.141 238.398 856.423 238.448 856.559 238.274C856.73 238.065 857.063 238.182 857.063 238.451V239.249C857.063 239.477 857.348 239.579 857.493 239.404C857.655 239.211 857.965 239.36 857.921 239.607L857.914 239.604Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.966 243.847L812.042 240.355C812.054 239.766 812.533 239.297 813.122 239.297C813.701 239.297 814.179 239.756 814.201 240.336L814.334 243.847L814.451 240.288C814.473 239.737 814.926 239.297 815.477 239.297C816.028 239.297 816.481 239.734 816.503 240.285L816.636 243.847L816.772 240.317C816.794 239.747 817.26 239.297 817.83 239.297C818.4 239.297 818.868 239.747 818.887 240.317L819.02 243.847L819.185 240.193C819.21 239.69 819.625 239.294 820.128 239.294C820.644 239.294 821.069 239.715 821.069 240.234V243.844",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.065 243.847L821.141 240.355C821.154 239.766 821.632 239.297 822.221 239.297C822.801 239.297 823.279 239.756 823.301 240.336L823.434 243.847L823.551 240.288C823.573 239.737 824.026 239.297 824.577 239.297C825.128 239.297 825.58 239.734 825.603 240.285L825.736 243.847L825.872 240.317C825.894 239.747 826.359 239.297 826.929 239.297C827.499 239.297 827.968 239.747 827.987 240.317L828.12 243.847L828.284 240.193C828.31 239.69 828.724 239.294 829.228 239.294C829.744 239.294 830.168 239.715 830.168 240.234V243.844",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.168 243.847L830.244 240.355C830.257 239.766 830.738 239.297 831.324 239.297C831.903 239.297 832.381 239.756 832.403 240.336L832.536 243.847L832.653 240.288C832.676 239.737 833.128 239.297 833.679 239.297C834.23 239.297 834.683 239.734 834.705 240.285L834.838 243.847L834.974 240.317C834.996 239.747 835.462 239.297 836.032 239.297C836.602 239.297 837.07 239.747 837.089 240.317L837.222 243.847L837.387 240.193C837.412 239.69 837.827 239.294 838.33 239.294C838.846 239.294 839.271 239.715 839.271 240.234V243.844",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.268 243.847L839.344 240.355C839.356 239.766 839.838 239.297 840.423 239.297C841.003 239.297 841.481 239.756 841.503 240.336L841.636 243.847L841.753 240.288C841.775 239.737 842.228 239.297 842.779 239.297C843.33 239.297 843.783 239.734 843.805 240.285L843.938 243.847L844.074 240.317C844.096 239.747 844.561 239.297 845.131 239.297C845.701 239.297 846.17 239.747 846.189 240.317L846.322 243.847L846.486 240.193C846.512 239.69 846.927 239.294 847.43 239.294C847.946 239.294 848.37 239.715 848.37 240.234V243.844",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.37 243.847L848.446 240.355C848.459 239.766 848.94 239.297 849.526 239.297C850.105 239.297 850.583 239.756 850.605 240.336L850.738 243.847L850.856 240.288C850.878 239.737 851.331 239.297 851.881 239.297C852.432 239.297 852.885 239.734 852.907 240.285L853.04 243.847L853.176 240.317C853.199 239.747 853.664 239.297 854.234 239.297C854.804 239.297 855.272 239.747 855.291 240.317L855.424 243.847L855.589 240.193C855.614 239.69 856.029 239.294 856.533 239.294C857.049 239.294 857.473 239.715 857.473 240.234V243.844",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.78 243.847L733.856 240.355C733.869 239.766 734.347 239.297 734.936 239.297C735.515 239.297 735.993 239.756 736.016 240.336L736.149 243.847L736.266 240.288C736.288 239.737 736.741 239.297 737.292 239.297C737.843 239.297 738.295 239.734 738.317 240.285L738.45 243.847L738.587 240.317C738.609 239.747 739.074 239.297 739.644 239.297C740.214 239.297 740.682 239.747 740.701 240.317L740.835 243.847L740.999 240.193C741.025 239.69 741.439 239.294 741.943 239.294C742.459 239.294 742.883 239.715 742.883 240.234V243.844",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.883 243.847L742.959 240.355C742.971 239.766 743.45 239.297 744.038 239.297C744.618 239.297 745.096 239.756 745.118 240.336L745.251 243.847L745.368 240.288C745.39 239.737 745.843 239.297 746.394 239.297C746.945 239.297 747.398 239.734 747.42 240.285L747.553 243.847L747.689 240.317C747.711 239.747 748.177 239.297 748.747 239.297C749.316 239.297 749.785 239.747 749.804 240.317L749.937 243.847L750.102 240.193C750.127 239.69 750.542 239.294 751.045 239.294C751.561 239.294 751.986 239.715 751.986 240.234V243.844",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.981 243.847L752.057 240.355C752.07 239.766 752.548 239.297 753.137 239.297C753.716 239.297 754.195 239.756 754.217 240.336L754.35 243.847L754.467 240.288C754.489 239.737 754.942 239.297 755.493 239.297C756.044 239.297 756.496 239.734 756.519 240.285L756.652 243.847L756.788 240.317C756.81 239.747 757.275 239.297 757.845 239.297C758.415 239.297 758.884 239.747 758.903 240.317L759.036 243.847L759.2 240.193C759.226 239.69 759.64 239.294 760.144 239.294C760.66 239.294 761.084 239.715 761.084 240.234V243.844",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.082 243.847L761.158 240.355C761.171 239.766 761.649 239.297 762.238 239.297C762.817 239.297 763.295 239.756 763.317 240.336L763.45 243.847L763.568 240.288C763.59 239.737 764.042 239.297 764.593 239.297C765.144 239.297 765.597 239.734 765.619 240.285L765.752 243.847L765.888 240.317C765.91 239.747 766.376 239.297 766.946 239.297C767.516 239.297 767.984 239.747 768.003 240.317L768.136 243.847L768.301 240.193C768.326 239.69 768.741 239.294 769.244 239.294C769.761 239.294 770.185 239.715 770.185 240.234V243.844",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.185 243.847L770.261 240.355C770.273 239.766 770.751 239.297 771.34 239.297C771.92 239.297 772.398 239.756 772.42 240.336L772.553 243.847L772.67 240.288C772.692 239.737 773.145 239.297 773.696 239.297C774.247 239.297 774.7 239.734 774.722 240.285L774.855 243.847L774.991 240.317C775.013 239.747 775.478 239.297 776.048 239.297C776.618 239.297 777.087 239.747 777.106 240.317L777.239 243.847L777.403 240.193C777.429 239.69 777.844 239.294 778.347 239.294C778.863 239.294 779.287 239.715 779.287 240.234V243.844",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.26 245.295H734.401V247.777H742.26V245.295Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.22 246.535H760.461C761.145 246.535 761.702 247.089 761.702 247.776C761.702 248.46 761.148 249.017 760.461 249.017H759.22C758.536 249.017 757.979 248.463 757.979 247.776C757.979 247.092 758.533 246.535 759.22 246.535Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.51 240.755C847.9 240.859 848.992 242.021 848.992 243.437V244.057H846.51V240.755Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.917 240.755C857.527 240.859 856.435 242.021 856.435 243.437V244.057H858.917V240.755Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.207 241.985C819.207 241.301 818.653 240.744 817.966 240.744C817.279 240.744 816.725 241.298 816.725 241.985V244.053H819.207V241.985Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.683 241.985C833.683 241.301 833.129 240.744 832.442 240.744C831.755 240.744 831.201 241.298 831.201 241.985V244.053H833.683V241.985Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.113 246.535H775.354C776.038 246.535 776.595 247.089 776.595 247.776C776.595 248.46 776.041 249.017 775.354 249.017H774.113C773.429 249.017 772.872 248.463 772.872 247.776C772.872 247.092 773.426 246.535 774.113 246.535Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.551 246.535H818.792C819.476 246.535 820.033 247.089 820.033 247.776C820.033 248.46 819.479 249.017 818.792 249.017H817.551C816.867 249.017 816.31 248.463 816.31 247.776C816.31 247.092 816.864 246.535 817.551 246.535Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.03 246.535H833.271C833.955 246.535 834.512 247.089 834.512 247.776C834.512 248.46 833.955 249.017 833.271 249.017H832.03C831.346 249.017 830.789 248.463 830.789 247.776C830.789 247.092 831.346 246.535 832.03 246.535Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.333 240.755C733.723 240.859 734.815 242.021 734.815 243.437V244.057H732.333V240.755Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.745 240.755C743.355 240.859 742.263 242.021 742.263 243.437V244.057H744.745V240.755Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.876 241.985C760.876 241.301 760.322 240.744 759.635 240.744C758.948 240.744 758.394 241.298 758.394 241.985V244.053H760.876V241.985Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.77 241.985C775.77 241.301 775.216 240.744 774.529 240.744C773.842 240.744 773.288 241.298 773.288 241.985V244.053H775.77V241.985Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.85 245.295H848.991V247.777H856.85V245.295Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.781 245.295L389.603 269.909V271.976L410.908 267.838L496.54 250.462L501.505 252.118L481.65 264.529L471.721 273.217C477.1 270.529 488.805 264.779 492.611 263.288C497.37 261.426 516.604 252.118 519.292 250.877C524.463 248.489 522.81 245.292 519.292 244.671C510.025 242.686 497.091 244.256 491.781 245.291V245.295Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.046 283.147H402.635L404.091 277.926C404.607 276.08 403.217 274.253 401.302 274.253H389.603V271.977L494.08 251.08C497.506 250.396 500.979 249.975 504.472 249.826C505.7 249.776 506.203 251.381 505.165 252.04L471.635 273.361C469.859 274.488 469.089 276.685 469.77 278.673L471.299 283.144H466.129V277.141C466.129 276.258 465.23 275.656 464.413 275.995L460.132 277.768V274.25L483.505 257.91C484.369 257.438 483.8 256.004 482.847 256.254C465.759 260.718 438.944 266.468 430.554 268.459C422.914 270.274 415.451 272.246 411.082 273.646C409.356 274.196 408.334 275.89 408.508 277.692L409.043 283.144L409.046 283.147Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.634 269.289V274.668",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.805 268.461V273.631",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.455 265.774V270.533",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.148 267.426V273.011",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.493 266.6V271.77",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.841 274.666L412.561 272.805",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.374 283.147V277.482C467.374 276.225 467.941 275.038 468.929 274.259C471.101 272.546 473.954 270.333 476.639 268.291C478.329 266.933 480.378 265.403 482.844 263.697C483.183 263.459 483.481 263.254 483.743 263.079C488.382 259.923 494.394 256.196 502.123 251.909C492.612 257.184 486.862 261.006 483.747 263.076H483.743C483.436 263.288 483.139 263.491 482.844 263.694C481.315 264.77 479.042 266.461 476.639 268.288C472.025 271.986 470.078 274.392 469.648 275.488V283.14H467.371L467.374 283.147Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.592 276.875L405.322 282.942H409.046C408.91 282.391 408.963 280.624 408.631 277.977C408.298 275.33 409.736 274.254 410.698 274.048L427.245 269.289L409.996 273.38C408.279 273.788 406.95 275.15 406.592 276.875Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.136 275.699L494.264 255.844L502.331 251.915",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.781 245.295L389.603 269.909V268.668L491.781 242.398C497.781 241.227 511.681 239.587 519.292 242.398C522.272 243.392 523.773 244.329 524.257 244.675C524.257 246.331 524.463 248.192 523.431 249.019C522.604 249.68 488.612 265.429 471.721 273.218C477.1 270.53 488.805 264.78 492.611 263.289C497.37 261.427 516.604 252.118 519.292 250.877C524.463 248.49 522.81 245.292 519.292 244.671C510.025 242.686 497.091 244.257 491.781 245.292V245.295Z",
    fill: "#FBDC99",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.603 266.6V268.668L418.766 261.221C441.86 254.81 491.079 241.778 503.158 240.951C515.237 240.125 522.256 243.088 524.254 244.675V240.593C524.254 239.612 523.975 238.627 523.212 238.016C521.243 236.449 517.44 234.913 513.913 234.746C502.993 233.751 490.61 236.538 485.782 238.054L389.603 266.597V266.6Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.603 269.703V271.98",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.889 256.259L502.123 251.915",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.225 243.848L502.328 249.848",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.916 244.674L500.26 250.053",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.914 243.848L503.984 249.848",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.882 244.054V250.054",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.466 283.147V259.569H981.783L991.298 253.984L1001.23 257.913L1013.02 250.881L1015.29 283.147H887.469H887.466Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.948 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.431 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.909 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.392 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.875 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.355 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.838 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.32 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.803 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.286 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.769 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.249 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.731 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.214 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.697 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.179 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.659 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.141 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.623 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.105 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.587 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.069 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.552 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.035 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.517 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.999 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.479 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.963 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.445 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.928 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.41 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.89 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.372 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.854 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.335 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.817 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.301 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.783 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.266 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.748 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.23 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.712 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.194 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.677 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.159 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.64 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.12 262.877V283.147",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.6 262.257V283.147",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.08 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.57 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.05 261.225V283.15",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.672 252.327C883.204 252.492 876.432 250.88 873.607 250.051C884.157 260.806 885.81 262.874 887.672 263.909C896.36 264.736 894.289 262.668 905.459 262.668C916.629 262.668 922.835 265.565 928.626 265.771C934.417 265.977 935.864 262.668 942.899 262.668C949.935 262.668 953.655 267.427 958.414 267.427C963.172 267.427 962.963 262.462 969.375 262.256C975.786 262.051 978.683 268.668 981.786 268.668C987.786 268.668 984.683 261.842 990.68 261.636C996.68 261.43 996.471 269.494 1000.4 269.494C1004.33 269.494 1004.12 261.842 1009.09 261.221C1014.05 260.6 1013.85 278.597 1015.29 282.938C1019.22 271.562 1021.08 250.051 1015.29 250.051C1009.5 250.051 1009.91 262.668 1004.95 262.874C999.989 263.08 1003.09 252.324 996.474 251.498C989.857 250.671 989.857 260.806 984.683 261.218C979.513 261.633 980.545 251.498 973.307 251.498C966.069 251.498 965.24 259.15 959.655 259.15C954.07 259.15 952.417 251.498 942.899 251.498C936.488 251.498 933.179 256.256 927.385 256.256C921.591 256.256 915.037 251.615 907.115 250.877C898.221 250.051 893.257 252.118 887.672 252.324V252.327Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.84 261.43C1014.96 247.53 1015.77 269.703 1015.29 282.526C1013.84 266.391 1012.39 264.697 1011.57 262.877C1010.53 260.6 1009.08 261.221 1007.84 261.43Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.672 270.738H889.948",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.672 277.356H889.948",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.909 267.426H897.186",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.909 274.048H897.186",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.909 280.664H897.186",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.875 267.426H902.151",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.875 274.048H902.151",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.875 280.664H902.151",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.838 267.426H907.114",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.838 274.048H907.114",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.838 280.664H907.114",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.803 267.426H912.079",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.803 274.048H912.079",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.803 280.664H912.079",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.769 267.426H917.045",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.769 274.048H917.045",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.769 280.664H917.045",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.731 267.426H922.008",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.731 274.048H922.008",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.731 280.664H922.008",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.697 267.426H926.974",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.697 274.048H926.974",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.697 280.664H926.974",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.659 267.426H931.936",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.659 274.048H931.936",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.659 280.664H931.936",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.623 267.426H936.9",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.623 274.048H936.9",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.623 280.664H936.9",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.587 267.426H941.863",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.587 274.048H941.863",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.587 280.664H941.863",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.552 267.426H946.828",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.552 274.048H946.828",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.552 280.664H946.828",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.517 267.426H951.793",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.517 274.048H951.793",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.517 280.664H951.793",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.479 267.426H956.756",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.479 274.048H956.756",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.479 280.664H956.756",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.445 267.426H961.722",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.445 274.048H961.722",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.445 280.664H961.722",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.41 267.426H966.687",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.41 274.048H966.687",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.41 280.664H966.687",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.372 267.426H971.649",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.372 274.048H971.649",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.372 280.664H971.649",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.335 267.426H976.611",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.335 274.048H976.611",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.335 280.664H976.611",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.23 267.426H991.507",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.23 274.048H991.507",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.23 280.664H991.507",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.194 267.426H996.471",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.194 274.048H996.471",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.194 280.664H996.471",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.12 267.426H1006.4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.12 274.048H1006.4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.12 280.664H1006.4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.301 274.048H981.577",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.301 280.664H981.577",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.266 274.048H986.542",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.266 280.664H986.542",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.152 267.426H892.429",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.152 274.048H892.429",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.152 280.664H892.429",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.636 270.738H894.912",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.636 277.356H894.912",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.601 270.738H899.877",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.601 277.356H899.877",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.565 270.738H904.842",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.565 277.356H904.842",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.526 270.738H909.803",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.526 277.356H909.803",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.491 270.738H914.768",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.491 277.356H914.768",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.456 270.738H919.733",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.456 277.356H919.733",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.42 270.738H924.696",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.42 277.356H924.696",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.385 270.738H929.661",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.385 277.356H929.661",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.349 270.738H934.625",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.349 277.356H934.625",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.314 270.738H939.591",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.314 277.356H939.591",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.275 270.738H944.552",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.275 277.356H944.552",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.239 270.738H949.516",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.239 277.356H949.516",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.204 270.738H954.481",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.204 277.356H954.481",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.17 270.738H959.446",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.17 277.356H959.446",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.134 270.738H964.41",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.134 277.356H964.41",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.098 270.738H969.374",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.098 277.356H969.374",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.063 270.738H974.34",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.063 277.356H974.34",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.027 270.738H979.304",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.027 277.356H979.304",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.989 270.738H984.266",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.989 277.356H984.266",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.953 270.738H989.23",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.953 277.356H989.23",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.918 270.738H994.194",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.918 277.356H994.194",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.882 270.738H999.158",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.882 277.356H999.158",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.85 270.738H1004.12",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.85 277.356H1004.12",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.81 270.738H1009.09",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.81 277.356H1009.09",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.78 270.738H1013.64",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.78 277.356H1014.05",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.641 261.43C994.1 260.014 989.85 259.568 987.368 262.877C991.506 259.98 993.552 262.095 994.815 263.497C996.677 265.565 996.677 269.839 1000.81 269.288C997.091 266.185 998.127 263.703 995.645 261.43H995.641Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.346 261.556C973.07 259.992 966.478 260.188 963.375 264.738C967.304 261.015 971.731 262.455 973.51 263.082C977.028 264.323 978.06 269.012 982.198 268.462C978.949 267.635 978.658 263.833 975.346 261.556Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.481 261.43C945.825 260.67 940.623 260.81 934.417 264.533C941.655 261.636 946.081 262.665 947.861 263.292C951.378 264.533 953.861 267.015 958.201 267.221C954.953 266.395 952.822 262.671 948.481 261.43Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.112 261.015C908.768 260.6 902.968 260.41 893.257 263.912C903.807 261.844 909.651 262.689 912.491 262.876C918.077 263.244 921.828 265.577 928.626 265.773C923.548 264.994 919.979 261.67 913.112 261.015Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.455 266.6H554.247V283.146H675.455V266.6Z",
    fill: "#D8D0C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.107 220.475L678.969 242.191L686.827 242.812L683.104 220.475H683.107Z",
    fill: "#B7594C",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.107 220.475L681.66 242.812H686.831L683.107 220.475Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.039 242.811C681.039 242.128 681.593 241.57 682.28 241.57C682.967 241.57 683.521 242.124 683.521 242.811V249.638H681.039V242.811Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.969 242.606C678.969 242.036 679.431 241.57 680.004 241.57C680.577 241.57 681.039 242.033 681.039 242.606V249.638H678.972V242.606H678.969Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.522 243.226C683.522 242.311 684.263 241.57 685.178 241.57C686.093 241.57 686.834 242.311 686.834 243.226V249.638H683.526V243.226H683.522Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.281 248.812C682.281 247.327 683.485 246.124 684.97 246.124C686.455 246.124 687.658 247.327 687.658 248.812V253.362H682.278V248.812H682.281Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.143 248.607C678.143 247.464 679.071 246.539 680.21 246.539C681.35 246.539 682.278 247.467 682.278 248.607V255.433H678.14V248.607H678.143Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.522 249.539C683.522 248.795 684.127 248.193 684.868 248.193H685.074C685.815 248.193 686.419 248.795 686.419 249.539C686.419 250.283 685.815 250.885 685.074 250.885H684.868C684.127 250.885 683.522 250.283 683.522 249.539Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.384 249.847C679.384 249.391 679.757 249.021 680.21 249.021C680.663 249.021 681.037 249.391 681.037 249.847V250.467C681.037 250.923 680.663 251.294 680.21 251.294C679.757 251.294 679.384 250.923 679.384 250.467V249.847Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.004 259.362L686.415 251.295L700.689 259.362H680.004Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.416 251.295L674.005 257.501L674.42 257.915V261.639L680.005 259.571L686.416 251.298V251.295Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.48 283.56V259.361H680.21L674.419 261.638V283.564H700.48V283.56Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.419 266.807H555.279V283.353H674.419V266.807Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.279 259.775V266.807H674.419V257.707H553.648L555.232 259.645L555.276 259.702V259.775H555.279Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.574 197.309H611.748C611.405 197.309 611.127 197.586 611.127 197.929V258.739C611.127 259.082 611.405 259.359 611.748 259.359H612.574C612.917 259.359 613.194 259.082 613.194 258.739V197.929C613.194 197.586 612.917 197.309 612.574 197.309Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.539 197.309H616.712C616.37 197.309 616.092 197.586 616.092 197.929V258.739C616.092 259.082 616.37 259.359 616.712 259.359H617.539C617.881 259.359 618.159 259.082 618.159 258.739V197.929C618.159 197.586 617.881 197.309 617.539 197.309Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.898 272.601H556.107V283.356H561.898V272.601Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.898 272.601H556.107V274.668H561.898V272.601Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.349 268.047H556.107V270.944H557.349V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.832 268.047H558.176V270.944H559.832V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.898 268.047H560.657V270.944H561.898V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.413 272.601H565.622V283.356H571.413V272.601Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.863 268.047H565.622V270.944H566.863V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.346 268.047H567.69V270.944H569.346V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.414 268.047H570.173V270.944H571.414V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.616 272.601H583.825V283.356H589.616V272.601Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.066 268.047H583.825V270.944H585.066V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.549 268.047H585.894V270.944H587.549V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.616 268.047H588.375V270.944H589.616V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.13 272.601H593.339V283.356H599.13V272.601Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.58 268.047H593.339V270.944H594.58V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.063 268.047H595.407V270.944H597.063V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.131 268.047H597.89V270.944H599.131V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.644 272.601H602.854V283.356H608.644V272.601Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.095 268.047H602.854V270.944H604.095V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.577 268.047H604.921V270.944H606.577V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.645 268.047H607.403V270.944H608.645V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.259 272.601H621.468V283.356H627.259V272.601Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.709 268.047H621.468V270.944H622.709V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.194 268.047H623.538V270.944H625.194V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.259 268.047H626.018V270.944H627.259V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.773 272.601H630.982V283.356H636.773V272.601Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.224 268.047H630.982V270.944H632.224V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.709 268.047H633.053V270.944H634.709V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.776 268.047H635.535V270.944H636.776V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.593 272.601H667.802V283.356H673.593V272.601Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.043 268.047H667.802V270.944H669.043V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.525 268.047H669.869V270.944H671.525V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.59 275.909H683.107V283.356H685.59V275.909Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.384 276.32H678.143V280.87H679.384V276.32Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.901 276.32H675.66V280.87H676.901V276.32Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.143 274.252H679.384V269.345L678.143 269.655V274.252Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.66 274.252H676.901V269.759L675.66 270.069V274.252Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.143 263.039V266.161L679.384 266.006V262.729L678.143 263.039Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.66 263.452V266.574L676.901 266.419V263.142L675.66 263.452Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.001 276.32H695.519V280.87H698.001V276.32Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.593 268.047H672.352V270.944H673.593V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.078 272.601H658.287V283.356H664.078V272.601Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.528 268.047H658.287V270.944H659.528V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.01 268.047H660.354V270.944H662.01V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.079 268.047H662.838V270.944H664.079V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.288 272.601H640.497V283.356H646.288V272.601Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.738 268.047H640.497V270.944H641.738V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.222 268.047H642.566V270.944H644.222V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.29 268.047H645.049V270.944H646.29V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.972 265.152H664.904V283.355H666.972V265.152Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.669 265.152H637.602V283.355H639.669V265.152Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.155 265.152H628.088V283.355H630.155V265.152Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.024 265.152H599.956V283.355H602.024V265.152Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.511 265.152H590.443V283.355H592.511V265.152Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.793 265.152H562.726V283.355H564.793V265.152Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.655 267.014C572.655 264.158 574.973 261.844 577.826 261.844C580.678 261.844 582.996 264.158 582.996 267.014V283.355H572.655V267.014Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.117 267.014C647.117 264.158 649.435 261.844 652.288 261.844C655.14 261.844 657.458 264.158 657.458 267.014V283.355H647.117V267.014Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.21 258.12C680.21 257.664 680.584 257.294 681.037 257.294C681.489 257.294 681.863 257.664 681.863 258.12V283.561H680.207V258.12H680.21Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.931 263.084C695.931 262.628 696.305 262.258 696.757 262.258C697.21 262.258 697.584 262.628 697.584 263.084V265.772H695.928V263.084H695.931Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.522 263.084C683.522 262.628 683.895 262.258 684.348 262.258C684.801 262.258 685.174 262.628 685.174 263.084V265.772H683.519V263.084H683.522Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.107 269.702C683.107 269.018 683.661 268.461 684.349 268.461C685.036 268.461 685.59 269.015 685.59 269.702V273.631H683.107V269.702Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.519 269.702C695.519 269.018 696.073 268.461 696.76 268.461C697.447 268.461 698.001 269.015 698.001 269.702V273.631H695.519V269.702Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.887 264.944C609.887 262.088 612.204 259.773 615.057 259.773C617.91 259.773 620.227 262.088 620.227 264.944V283.352H609.887V264.944Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.278 283.355V264.532L550.314 263.497H531.285V283.352H555.278V283.355Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.321 263.497L545.559 254.188L550.524 263.497H532.321Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.317 263.291L545.768 254.397L553.626 257.915L555.282 259.777V264.741L550.317 263.294V263.291Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.598 280.045H537.08V273.428C537.08 272.744 536.526 272.187 535.839 272.187C535.152 272.187 534.598 272.741 534.598 273.428V280.045Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.009 269.288H536.665V267.221C536.665 266.765 536.291 266.395 535.838 266.395C535.386 266.395 535.012 266.765 535.012 267.221V269.288H535.009Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.764 269.288H547.42V267.221C547.42 266.765 547.046 266.395 546.593 266.395C546.14 266.395 545.767 266.765 545.767 267.221V269.288H545.764Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.353 280.045H547.835V273.428C547.835 272.744 547.281 272.187 546.594 272.187C545.907 272.187 545.353 272.741 545.353 273.428V280.045Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.733 263.291C538.733 261.806 539.936 260.603 541.421 260.603C542.906 260.603 544.109 261.806 544.109 263.291V283.355H538.729V263.291H538.733Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.285 261.636C531.285 261.066 531.747 260.601 532.321 260.601C532.894 260.601 533.356 261.063 533.356 261.636V283.353H531.288V261.636H531.285Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.076 261.429C549.076 260.973 549.45 260.603 549.903 260.603C550.356 260.603 550.729 260.973 550.729 261.429V283.355H549.073V261.429H549.076Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.389 269.288H542.045V267.221C542.045 266.765 541.671 266.395 541.218 266.395C540.765 266.395 540.392 266.765 540.392 267.221V269.288H540.389Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.974 280.045H542.871V273.633C542.871 272.832 542.222 272.187 541.424 272.187C540.626 272.187 539.977 272.836 539.977 273.633V280.045H539.974Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.481 267.426C573.481 265.026 575.425 263.082 577.825 263.082C580.225 263.082 582.169 265.026 582.169 267.426V283.352H573.481V267.426Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.722 283.356H580.513V275.498C580.513 273.899 579.218 272.601 577.616 272.601C576.014 272.601 574.719 273.896 574.719 275.498V283.356H574.722Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.964 268.047H574.723V270.944H575.964V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.446 268.047H576.79V270.944H578.446V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.513 268.047H579.271V270.944H580.513V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.943 267.426C647.943 265.026 649.887 263.082 652.287 263.082C654.687 263.082 656.631 265.026 656.631 267.426V283.352H647.943V267.426Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.712 265.358C610.712 262.958 612.656 261.014 615.056 261.014C617.456 261.014 619.4 262.958 619.4 265.358V283.354H610.712V265.358Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.953 283.356H617.744V275.498C617.744 273.899 616.449 272.601 614.847 272.601C613.245 272.601 611.95 273.896 611.95 275.498V283.356H611.953Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.194 268.047H611.953V270.944H613.194V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.678 268.047H614.022V270.944H615.678V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.745 268.047H616.504V270.944H617.745V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.184 283.356H654.975V275.498C654.975 273.899 653.68 272.601 652.078 272.601C650.476 272.601 649.181 273.896 649.181 275.498V283.356H649.184Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.184 283.355H654.975V277.149C654.975 275.55 653.68 274.252 652.078 274.252C650.476 274.252 649.181 275.547 649.181 277.149V283.355H649.184Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.953 283.355H617.744V277.149C617.744 275.55 616.449 274.252 614.847 274.252C613.245 274.252 611.95 275.547 611.95 277.149V283.355H611.953Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.722 283.355H580.513V277.149C580.513 275.55 579.218 274.252 577.616 274.252C576.014 274.252 574.719 275.547 574.719 277.149V283.355H574.722Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.426 268.047H649.185V270.944H650.426V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.909 268.047H651.253V270.944H652.909V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.975 268.047H653.734V270.944H654.975V268.047Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.831 259.983C686.831 257.811 688.588 256.054 690.76 256.054C692.932 256.054 694.69 257.814 694.69 259.983V283.561H686.831V259.983Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.621 276.32H689.312V280.87H692.621V276.32Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.484 263.084C688.484 262.628 688.857 262.258 689.31 262.258C689.763 262.258 690.136 262.628 690.136 263.084V265.772H688.48V263.084H688.484Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.38 263.084C691.38 262.628 691.754 262.258 692.206 262.258C692.659 262.258 693.033 262.628 693.033 263.084V265.772H691.377V263.084H691.38Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.313 269.908C689.313 269.107 689.962 268.461 690.76 268.461C691.558 268.461 692.207 269.11 692.207 269.908V273.631H689.31V269.908H689.313Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.413 272.601H565.622V274.668H571.413V272.601Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.616 272.601H583.825V274.668H589.616V272.601Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.13 272.601H593.339V274.668H599.13V272.601Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.644 272.601H602.854V274.668H608.644V272.601Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.259 272.601H621.468V274.668H627.259V272.601Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.773 272.601H630.982V274.668H636.773V272.601Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.288 272.601H640.497V274.668H646.288V272.601Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.078 272.601H658.287V274.668H664.078V272.601Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.593 272.601H667.802V274.668H673.593V272.601Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.239 258.12C699.239 257.664 699.612 257.294 700.065 257.294C700.518 257.294 700.891 257.664 700.891 258.12V283.561H699.235V258.12H699.239Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.165 259.774H35.2881V283.353H110.165V259.774Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.582 259.774H149.464V283.353H225.582V259.774Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2872 266.396H10.0527V283.357H35.2872V266.396Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3547 265.153C37.3547 264.01 38.2824 263.086 39.4222 263.086C40.5621 263.086 41.4898 264.014 41.4898 265.153V268.462H37.3516V265.153H37.3547Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3206 265.153C42.3206 264.01 43.2482 263.086 44.3881 263.086C45.5279 263.086 46.4556 264.014 46.4556 265.153V268.462H42.3174V265.153H42.3206Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2834 265.153C47.2834 264.01 48.2111 263.086 49.351 263.086C50.4908 263.086 51.4185 264.014 51.4185 265.153V268.462H47.2803V265.153H47.2834Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2483 265.153C52.2483 264.01 53.176 263.086 54.3158 263.086C55.4556 263.086 56.3833 264.014 56.3833 265.153V268.462H52.2451V265.153H52.2483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2102 265.153C57.2102 264.01 58.1379 263.086 59.2777 263.086C60.4175 263.086 61.3452 264.014 61.3452 265.153V268.462H57.207V265.153H57.2102Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.175 265.153C62.175 264.01 63.1027 263.086 64.2426 263.086C65.3824 263.086 66.3101 264.014 66.3101 265.153V268.462H62.1719V265.153H62.175Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5539 265.153C67.5539 264.01 68.4816 263.086 69.6215 263.086C70.7613 263.086 71.689 264.014 71.689 265.153V268.462H67.5508V265.153H67.5539Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5188 265.153C72.5188 264.01 73.4465 263.086 74.5863 263.086C75.7261 263.086 76.6538 264.014 76.6538 265.153V268.462H72.5156V265.153H72.5188Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4827 265.153C77.4827 264.01 78.4103 263.086 79.5502 263.086C80.69 263.086 81.6177 264.014 81.6177 265.153V268.462H77.4795V265.153H77.4827Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4446 265.153C82.4446 264.01 83.3723 263.086 84.5121 263.086C85.6519 263.086 86.5796 264.014 86.5796 265.153V268.462H82.4414V265.153H82.4446Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4084 265.153C87.4084 264.01 88.3361 263.086 89.4759 263.086C90.6158 263.086 91.5435 264.014 91.5435 265.153V268.462H87.4053V265.153H87.4084Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3733 265.153C92.3733 264.01 93.301 263.086 94.4408 263.086C95.5806 263.086 96.5083 264.014 96.5083 265.153V268.462H92.3701V265.153H92.3733Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3381 265.153C97.3381 264.01 98.2658 263.086 99.4056 263.086C100.545 263.086 101.473 264.014 101.473 265.153V268.462H97.335V265.153H97.3381Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.303 265.153C102.303 264.01 103.231 263.086 104.37 263.086C105.51 263.086 106.438 264.014 106.438 265.153V268.462H102.3V265.153H102.303Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.268 265.153C107.268 264.01 108.195 263.086 109.335 263.086C110.475 263.086 111.403 264.014 111.403 265.153V268.462H107.265V265.153H107.268Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.874 265.153C149.874 264.01 150.802 263.086 151.942 263.086C153.082 263.086 154.009 264.014 154.009 265.153V268.462H149.871V265.153H149.874Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.839 265.153C154.839 264.01 155.767 263.086 156.907 263.086C158.046 263.086 158.974 264.014 158.974 265.153V268.462H154.836V265.153H154.839Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.804 265.153C159.804 264.01 160.732 263.086 161.871 263.086C163.011 263.086 163.939 264.014 163.939 265.153V268.462H159.801V265.153H159.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.084 249.019H117.193V259.774H144.084V249.019Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.768 265.153C164.768 264.01 165.696 263.086 166.835 263.086C167.975 263.086 168.903 264.014 168.903 265.153V268.462H164.765V265.153H164.768Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.733 265.153C169.733 264.01 170.66 263.086 171.8 263.086C172.94 263.086 173.868 264.014 173.868 265.153V268.462H169.729V265.153H169.733Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.697 265.153C174.697 264.01 175.624 263.086 176.764 263.086C177.904 263.086 178.832 264.014 178.832 265.153V268.462H174.693V265.153H174.697Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.073 265.153C180.073 264.01 181.001 263.086 182.141 263.086C183.281 263.086 184.209 264.014 184.209 265.153V268.462H180.07V265.153H180.073Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.038 265.153C185.038 264.01 185.966 263.086 187.106 263.086C188.246 263.086 189.173 264.014 189.173 265.153V268.462H185.035V265.153H185.038Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.003 265.153C190.003 264.01 190.931 263.086 192.071 263.086C193.21 263.086 194.138 264.014 194.138 265.153V268.462H190V265.153H190.003Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.967 265.153C194.967 264.01 195.895 263.086 197.035 263.086C198.174 263.086 199.102 264.014 199.102 265.153V268.462H194.964V265.153H194.967Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.929 265.153C199.929 264.01 200.857 263.086 201.996 263.086C203.136 263.086 204.064 264.014 204.064 265.153V268.462H199.926V265.153H199.929Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.893 265.153C204.893 264.01 205.82 263.086 206.96 263.086C208.1 263.086 209.028 264.014 209.028 265.153V268.462H204.89V265.153H204.893Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.858 265.153C209.858 264.01 210.785 263.086 211.925 263.086C213.065 263.086 213.993 264.014 213.993 265.153V268.462H209.854V265.153H209.858Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.823 265.153C214.823 264.01 215.75 263.086 216.89 263.086C218.03 263.086 218.958 264.014 218.958 265.153V268.462H214.819V265.153H214.823Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.786 265.153C219.786 264.01 220.714 263.086 221.854 263.086C222.994 263.086 223.921 264.014 223.921 265.153V268.462H219.783V265.153H219.786Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.022 255.018C118.022 253.761 119.042 252.741 120.299 252.741C121.556 252.741 122.575 253.761 122.575 255.018V258.535H118.026V255.018H118.022Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.399 255.018C123.399 253.761 124.419 252.741 125.676 252.741C126.933 252.741 127.952 253.761 127.952 255.018V258.535H123.403V255.018H123.399Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.948 255.018C127.948 253.761 128.968 252.741 130.225 252.741C131.482 252.741 132.501 253.761 132.501 255.018V258.535H127.951V255.018H127.948Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.328 255.018C133.328 253.761 134.348 252.741 135.605 252.741C136.862 252.741 137.881 253.761 137.881 255.018V258.535H133.331V255.018H133.328Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.878 255.018C137.878 253.761 138.897 252.741 140.154 252.741C141.411 252.741 142.431 253.761 142.431 255.018V258.535H137.881V255.018H137.878Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.222 235.781H124.64V249.019H136.222V235.781Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.367 237.021H125.47V247.362H128.367V237.021Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.087 237.021H129.19V247.362H132.087V237.021Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.396 237.021H132.914V247.362H135.396V237.021Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.367 237.021H125.47V237.848H128.367V237.021Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.087 237.021H129.19V237.848H132.087V237.021Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.225 231.646C130.567 231.646 130.846 231.925 130.846 232.267V233.923C130.846 234.265 130.567 234.544 130.225 234.544C129.883 234.544 129.604 234.265 129.604 233.923V232.267C129.604 231.925 129.883 231.646 130.225 231.646Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.64 232.267C124.64 231.925 124.918 231.646 125.26 231.646C125.602 231.646 125.881 231.925 125.881 232.267V233.093C125.881 233.822 125.343 234.426 124.64 234.528V232.267Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.984 232.267C134.984 231.925 135.263 231.646 135.605 231.646C135.947 231.646 136.226 231.925 136.226 232.267V234.528C135.523 234.426 134.984 233.825 134.984 233.093V232.267Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.396 237.021H132.914V237.848H135.396V237.021Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.705 247.366H122.158V249.022H138.705V247.366Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.707 256.465H124.64V258.532H126.707V256.465Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4215 257.708H48.5244V259.776H51.4215V257.708Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.898 257.708H75.001V259.776H77.898V257.708Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.373 257.708H101.476V259.776H104.373V257.708Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.393 257.708H156.496V259.776H159.393V257.708Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.869 257.708H182.972V259.776H185.869V257.708Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.343 257.708H209.446V259.776H212.343V257.708Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5578 255.64H50.3842C50.9541 255.64 51.4195 256.102 51.4195 256.675C51.4195 257.245 50.9573 257.71 50.3842 257.71H49.5578C48.9879 257.71 48.5225 257.248 48.5225 256.675C48.5225 256.105 48.9847 255.64 49.5578 255.64Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0324 255.64H76.8588C77.4287 255.64 77.8941 256.102 77.8941 256.675C77.8941 257.245 77.4319 257.71 76.8588 257.71H76.0324C75.4625 257.71 74.9971 257.248 74.9971 256.675C74.9971 256.105 75.4593 255.64 76.0324 255.64Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.508 255.64H103.334C103.904 255.64 104.37 256.102 104.37 256.675C104.37 257.245 103.907 257.71 103.334 257.71H102.508C101.938 257.71 101.473 257.248 101.473 256.675C101.473 256.105 101.935 255.64 102.508 255.64Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.528 255.64H158.354C158.924 255.64 159.389 256.102 159.389 256.675C159.389 257.245 158.927 257.71 158.354 257.71H157.528C156.958 257.71 156.492 257.248 156.492 256.675C156.492 256.105 156.954 255.64 157.528 255.64Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.003 255.64H184.829C185.399 255.64 185.865 256.102 185.865 256.675C185.865 257.245 185.403 257.71 184.829 257.71H184.003C183.433 257.71 182.968 257.248 182.968 256.675C182.968 256.105 183.43 255.64 184.003 255.64Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.479 255.64H211.305C211.875 255.64 212.34 256.102 212.34 256.675C212.34 257.245 211.878 257.71 211.305 257.71H210.479C209.909 257.71 209.443 257.248 209.443 256.675C209.443 256.105 209.906 255.64 210.479 255.64Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.258 256.465H129.19V258.532H131.258V256.465Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.637 256.465H134.569V258.532H136.637V256.465Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.222 234.955H124.64V235.781H136.222V234.955Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.743 219.234H126.711V235.781H133.743V219.234Z",
    fill: "#FEF6E0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.328 210.135H127.122V219.234H133.328V210.135Z",
    fill: "#FEF6E0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.315 210.134C133.211 209.204 132.422 208.479 131.466 208.479H128.984C128.024 208.479 127.236 209.204 127.135 210.134H133.318H133.315Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.192 208.479L129.601 172.489H130.434L130.842 208.479H129.192Z",
    fill: "#B7594C",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.019 167.525V172.49",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1133 271.36H40.2515V276.74H36.1133V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9395 280.044H39.4217V283.353H36.9395V280.044Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4932 280.044H44.8018V283.353H41.4932V280.044Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8691 280.044H50.1778V283.353H46.8691V280.044Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.249 280.044H55.5577V283.353H52.249V280.044Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.624 280.044H60.9327V283.353H57.624V280.044Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5889 280.044H65.8975V283.353H62.5889V280.044Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5889 280.044H65.8975V283.353H62.5889V280.044Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7939 279.218H70.4499V283.356H68.7939V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3447 279.218H75.827V283.356H73.3447V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7207 279.218H80.7882V283.356H78.7207V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6855 279.218H85.7531V283.356H83.6855V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0654 279.218H91.1329V283.356H89.0654V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0293 279.218H96.5116V283.356H94.0293V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9941 279.218H101.476V283.356H98.9941V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.955 279.218H106.437V283.356H103.955V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.509 279.218H110.165V283.356H108.509V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.29 279.218H151.946V283.356H150.29V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.84 279.218H157.322V283.356H154.84V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.219 279.218H162.286V283.356H160.219V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.181 279.218H167.248V283.356H165.181V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.559 279.218H172.626V283.356H170.559V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.108 279.218H177.591V283.356H175.108V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.073 279.218H182.556V283.356H180.073V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.453 279.218H187.935V283.356H185.453V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.829 279.218H192.485V283.356H190.829V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2872 266.396H10.0527V276.736H35.2872V266.396Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.968 279.218H197.865V283.356H194.968V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.758 279.218H203.24V283.356H200.758V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.723 279.218H208.62V283.356H205.723V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.099 279.218H213.996V283.356H211.099V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.478 279.218H219.375V283.356H216.478V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.442 279.218H224.339V283.356H221.442V279.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0791 271.36H45.2173V276.74H41.0791V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.042 271.36H50.1802V276.74H46.042V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3936 271.36H24.5318V276.74H20.3936V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3584 271.36H29.4966V276.74H25.3584V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4639 271.36H14.6021V276.74H10.4639V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4287 271.36H19.5669V276.74H15.4287V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3232 271.36H34.4614V276.74H30.3232V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1104 265.565H50.5926V268.462H48.1104V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0752 265.565H55.5575V268.462H53.0752V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4512 265.565H60.5187V268.462H58.4512V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.415 265.565H65.4826V268.462H63.415V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7939 265.565H70.8615V268.462H68.7939V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7598 265.565H75.8273V268.462H73.7598V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7207 265.565H80.7882V268.462H78.7207V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6855 265.565H85.7531V268.462H83.6855V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6504 265.565H90.7179V268.462H88.6504V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6152 265.565H95.6827V268.462H93.6152V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5791 265.565H100.647V268.462H98.5791V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.545 265.565H105.612V268.462H103.545V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.094 265.565H110.161V268.462H108.094V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.703 265.565H153.185V268.462H150.703V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.665 265.565H158.147V268.462H155.665V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.045 265.565H163.112V268.462H161.045V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.009 265.565H168.076V268.462H166.009V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.974 265.565H173.041V268.462H170.974V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.936 265.565H178.003V268.462H175.936V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.314 265.565H183.382V268.462H181.314V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.279 265.565H188.347V268.462H186.279V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.244 265.565H193.312V268.462H191.244V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.209 265.565H198.277V268.462H196.209V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.17 265.565H203.237V268.462H201.17V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.134 265.565H208.201V268.462H206.134V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.688 265.565H212.755V268.462H210.688V265.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.249 271.36H56.3872V276.74H52.249V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2109 271.36H61.3491V276.74H57.2109V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1738 271.36H66.312V276.74H62.1738V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5547 271.36H71.6929V276.74H67.5547V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5186 271.36H76.6568V276.74H72.5186V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4824 271.36H81.6206V276.74H77.4824V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4443 271.36H86.5825V276.74H82.4443V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4092 271.36H91.5474V276.74H87.4092V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.373 271.36H96.5112V276.74H92.373V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3379 271.36H101.476V276.74H97.3379V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.303 271.36H106.441V276.74H102.303V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.268 271.36H110.165V276.74H107.268V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.464 271.36H153.602V276.74H149.464V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.424 271.36H158.562V276.74H154.424V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.389 271.36H163.527V276.74H159.389V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.595 271.36H169.733V276.74H165.595V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.559 271.36H174.697V276.74H170.559V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.524 271.36H179.663V276.74H175.524V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9 271.36H185.039V276.74H180.9V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.864 271.36H190.002V276.74H185.864V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.829 271.36H194.967V276.74H190.829V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.813 266.396H225.578V282.942H250.813V266.396Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.793 271.36H199.931V276.74H195.793V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.758 271.36H204.896V276.74H200.758V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.723 271.36H209.861V276.74H205.723V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.688 271.36H214.826V276.74H210.688V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.648 271.36H219.787V276.74H215.648V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.614 271.36H224.752V276.74H220.614V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.403 271.36H230.542V276.74H226.403V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.368 271.36H235.506V276.74H231.368V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.333 271.36H240.471V276.74H236.333V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.298 271.36H245.436V276.74H241.298V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.263 271.36H250.401V276.74H246.263V271.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.813 266.396H225.578V282.942H250.813V266.396Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.813 266.396H225.578V268.463H250.813V266.396Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2872 266.396H10.0527V268.878H35.2872V266.396Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.225 228.337C131.482 228.337 132.501 227.318 132.501 226.061C132.501 224.803 131.482 223.784 130.225 223.784C128.967 223.784 127.948 224.803 127.948 226.061C127.948 227.318 128.967 228.337 130.225 228.337Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.226 226.887C130.682 226.887 131.052 226.517 131.052 226.061C131.052 225.604 130.682 225.234 130.226 225.234C129.769 225.234 129.399 225.604 129.399 226.061C129.399 226.517 129.769 226.887 130.226 226.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.675 255.635C126.475 255.635 127.122 254.987 127.122 254.188C127.122 253.389 126.475 252.741 125.675 252.741C124.876 252.741 124.229 253.389 124.229 254.188C124.229 254.987 124.876 255.635 125.675 255.635Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.225 255.635C131.024 255.635 131.672 254.987 131.672 254.188C131.672 253.389 131.024 252.741 130.225 252.741C129.426 252.741 128.778 253.389 128.778 254.188C128.778 254.987 129.426 255.635 130.225 255.635Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.605 255.635C136.404 255.635 137.052 254.987 137.052 254.188C137.052 253.389 136.404 252.741 135.605 252.741C134.806 252.741 134.158 253.389 134.158 254.188C134.158 254.987 134.806 255.635 135.605 255.635Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.019 163.437L130.611 165.26L130.659 165.403H132.726L131.175 166.53L131.054 166.619L131.102 166.761L131.694 168.585L130.143 167.458L130.022 167.369L129.902 167.458L128.351 168.585L128.943 166.761L128.99 166.619L128.87 166.53L127.318 165.403H129.386L129.433 165.26L130.025 163.437H130.019Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.087 211.375H131.261V213.857H132.087V211.375Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.775 211.375H127.948V213.857H128.775V211.375Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6963 273.841H50.1786V276.738H47.6963V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0752 273.841H55.5575V276.738H53.0752V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4512 273.841H60.5187V276.738H58.4512V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.415 273.841H65.4826V276.738H63.415V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7939 273.841H70.8615V276.738H68.7939V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7598 273.841H75.8273V276.738H73.7598V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7207 273.841H80.7882V276.738H78.7207V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6855 273.841H85.7531V276.738H83.6855V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6504 273.841H90.7179V276.738H88.6504V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6152 273.841H95.6827V276.738H93.6152V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5791 273.841H100.647V276.738H98.5791V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.545 273.841H105.612V276.738H103.545V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.094 273.841H110.161V276.738H108.094V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.703 273.841H153.185V276.738H150.703V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.665 273.841H158.147V276.738H155.665V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.045 273.841H163.112V276.738H161.045V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.009 273.841H168.076V276.738H166.009V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.974 273.841H173.041V276.738H170.974V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.936 273.841H178.003V276.738H175.936V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.314 273.841H183.382V276.738H181.314V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.279 273.841H188.347V276.738H186.279V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.244 273.841H193.312V276.738H191.244V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.209 273.841H198.277V276.738H196.209V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.17 273.841H203.237V276.738H201.17V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.134 273.841H208.201V276.738H206.134V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.688 273.841H212.755V276.738H210.688V273.841Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.46 259.774H110.161V283.353H149.46V259.774Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.608 267.635C117.608 266.036 118.903 264.738 120.505 264.738C122.108 264.738 123.403 266.033 123.403 267.635V276.735H117.612V267.635H117.608Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.537 267.635C127.537 266.036 128.832 264.738 130.434 264.738C132.036 264.738 133.331 266.033 133.331 267.635V276.735H127.54V267.635H127.537Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.878 267.635C137.878 266.036 139.173 264.738 140.775 264.738C142.377 264.738 143.672 266.033 143.672 267.635V276.735H137.881V267.635H137.878Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.46 276.736H110.161V283.354H149.46V276.736Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.46 276.736H110.161V277.563H149.46V276.736Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.46 278.392H110.161V279.218H149.46V278.392Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.46 280.044H110.161V280.87H149.46V280.044Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.46 281.7H110.161V282.527H149.46V281.7Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.579 259.774H35.2881V261.43H225.579V259.774Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.579 259.774H152.358V261.43H225.579V259.774Z",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.577 259.774H35.2881V261.43H110.577V259.774Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.611 264.324H113.473V276.736H117.611V264.324Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.538 264.324H123.399V276.736H127.538V264.324Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.878 264.324H133.328V276.736H137.878V264.324Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.219 264.324H143.669V276.736H148.219V264.324Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.602 270.53H139.534V276.736H141.602V270.53Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.672 270.53H129.604V276.736H131.672V270.53Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.331 270.53H119.264V276.736H121.331V270.53Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.332 267.636C115.904 267.636 116.368 267.173 116.368 266.601C116.368 266.029 115.904 265.565 115.332 265.565C114.76 265.565 114.297 266.029 114.297 266.601C114.297 267.173 114.76 267.636 115.332 267.636Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.332 270.944C115.904 270.944 116.368 270.48 116.368 269.908C116.368 269.337 115.904 268.873 115.332 268.873C114.76 268.873 114.297 269.337 114.297 269.908C114.297 270.48 114.76 270.944 115.332 270.944Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.332 274.257C115.904 274.257 116.368 273.794 116.368 273.222C116.368 272.65 115.904 272.187 115.332 272.187C114.76 272.187 114.297 272.65 114.297 273.222C114.297 273.794 114.76 274.257 115.332 274.257Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 267.636C125.832 267.636 126.295 267.173 126.295 266.601C126.295 266.029 125.832 265.565 125.26 265.565C124.688 265.565 124.225 266.029 124.225 266.601C124.225 267.173 124.688 267.636 125.26 267.636Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 270.944C125.832 270.944 126.295 270.48 126.295 269.908C126.295 269.337 125.832 268.873 125.26 268.873C124.688 268.873 124.225 269.337 124.225 269.908C124.225 270.48 124.688 270.944 125.26 270.944Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 274.257C125.832 274.257 126.295 273.794 126.295 273.222C126.295 272.65 125.832 272.187 125.26 272.187C124.688 272.187 124.225 272.65 124.225 273.222C124.225 273.794 124.688 274.257 125.26 274.257Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.605 267.636C136.176 267.636 136.64 267.173 136.64 266.601C136.64 266.029 136.176 265.565 135.605 265.565C135.033 265.565 134.569 266.029 134.569 266.601C134.569 267.173 135.033 267.636 135.605 267.636Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.605 270.944C136.176 270.944 136.64 270.48 136.64 269.908C136.64 269.337 136.176 268.873 135.605 268.873C135.033 268.873 134.569 269.337 134.569 269.908C134.569 270.48 135.033 270.944 135.605 270.944Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.605 274.257C136.176 274.257 136.64 273.794 136.64 273.222C136.64 272.65 136.176 272.187 135.605 272.187C135.033 272.187 134.569 272.65 134.569 273.222C134.569 273.794 135.033 274.257 135.605 274.257Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.945 267.636C146.517 267.636 146.981 267.173 146.981 266.601C146.981 266.029 146.517 265.565 145.945 265.565C145.374 265.565 144.91 266.029 144.91 266.601C144.91 267.173 145.374 267.636 145.945 267.636Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.945 270.944C146.517 270.944 146.981 270.48 146.981 269.908C146.981 269.337 146.517 268.873 145.945 268.873C145.374 268.873 144.91 269.337 144.91 269.908C144.91 270.48 145.374 270.944 145.945 270.944Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.945 274.257C146.517 274.257 146.981 273.794 146.981 273.222C146.981 272.65 146.517 272.187 145.945 272.187C145.374 272.187 144.91 272.65 144.91 273.222C144.91 273.794 145.374 274.257 145.945 274.257Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.398 266.185C123.398 266.527 123.135 266.888 122.6 267.173C122.075 267.455 121.334 267.632 120.504 267.632C119.675 267.632 118.934 267.452 118.408 267.173C117.873 266.888 117.61 266.53 117.61 266.185C117.61 265.84 117.873 265.482 118.408 265.197C118.934 264.916 119.675 264.738 120.504 264.738C121.334 264.738 122.075 264.919 122.6 265.197C123.135 265.482 123.398 265.84 123.398 266.185Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.328 266.185C133.328 266.527 133.065 266.888 132.53 267.173C132.004 267.455 131.263 267.632 130.434 267.632C129.604 267.632 128.864 267.452 128.338 267.173C127.803 266.888 127.54 266.53 127.54 266.185C127.54 265.84 127.803 265.482 128.338 265.197C128.864 264.916 129.604 264.738 130.434 264.738C131.263 264.738 132.004 264.919 132.53 265.197C133.065 265.482 133.328 265.84 133.328 266.185Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.67 266.185C143.67 266.527 143.407 266.888 142.872 267.173C142.346 267.455 141.605 267.632 140.776 267.632C139.946 267.632 139.205 267.452 138.68 267.173C138.145 266.888 137.882 266.53 137.882 266.185C137.882 265.84 138.145 265.482 138.68 265.197C139.205 264.916 139.946 264.738 140.776 264.738C141.605 264.738 142.346 264.919 142.872 265.197C143.407 265.482 143.67 265.84 143.67 266.185Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.653 234.954C124.757 234.023 125.545 233.298 126.502 233.298H134.36C135.319 233.298 136.108 234.023 136.209 234.954H124.649H124.653Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.632 219.234L124.355 214.685H136.096L133.819 219.234H126.629H126.632Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.775 215.927H127.948V218.409H128.775V215.927Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.431 215.927H129.604V218.409H130.431V215.927Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.087 215.927H131.261V218.409H132.087V215.927Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.158 246.331C122.158 245.989 122.437 245.71 122.779 245.71C123.121 245.71 123.399 245.989 123.399 246.331V247.157C123.399 247.885 122.861 248.49 122.158 248.591V246.331Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.466 246.331C137.466 245.989 137.744 245.71 138.086 245.71C138.428 245.71 138.707 245.989 138.707 246.331V248.591C138.004 248.49 137.466 247.888 137.466 247.157V246.331Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.78 251.915H1043.42V282.94H1120.78V251.915Z",
    fill: "#F4D7C9",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.78 273.427H1043.42V282.941H1120.78V273.427Z",
    fill: "#D7C7A3",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.8 258.12H1047.14V262.258H1048.8V258.12Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.05 254.188H1041.14V255.43H1123.05V254.188Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.8 266.807H1047.14V270.945H1048.8V266.807Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.21 275.495H1045.08V282.942H1049.21V275.495Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.14 275.495H1052.94V282.942H1059.14V275.495Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.24 275.495H1062.04V282.942H1068.24V275.495Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.34 275.495H1071.14V282.942H1077.34V275.495Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.41 276.941C1079.41 275.456 1080.61 274.253 1082.1 274.253C1083.58 274.253 1084.79 275.456 1084.79 276.941V282.941H1079.41V276.941H1079.41Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.21 276.736H1045.08V282.942H1049.21V276.736Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.14 276.736H1052.94V282.942H1059.14V276.736Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.24 276.736H1062.04V282.942H1068.24V276.736Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.34 276.736H1071.14V282.942H1077.34V276.736Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.41 278.183C1079.41 276.698 1080.61 275.495 1082.1 275.495C1083.58 275.495 1084.79 276.698 1084.79 278.183V282.942H1079.41V278.183H1079.41Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.83 258.12H1054.18V262.258H1055.83V258.12Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.83 266.807H1054.18V270.945H1055.83V266.807Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.38 258.12H1058.73V262.258H1060.38V258.12Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.38 266.807H1058.73V270.945H1060.38V266.807Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.93 258.12H1063.28V262.258H1064.93V258.12Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.93 266.807H1063.28V270.945H1064.93V266.807Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.07 258.12H1067.41V262.258H1069.07V258.12Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.07 266.807H1067.41V270.945H1069.07V266.807Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.03 258.12H1072.38V262.258H1074.03V258.12Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.03 266.807H1072.38V270.945H1074.03V266.807Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.17 258.12H1076.51V262.258H1078.17V258.12Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.17 266.807H1076.51V270.945H1078.17V266.807Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.02 251.915H1042.18V254.397H1122.02V251.915Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.45 252.741H1043.42V253.568H1050.45V252.741Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.38 252.741H1053.35V253.568H1060.38V252.741Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.31 252.741H1063.28V253.568H1070.31V252.741Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.24 252.741H1073.21V253.568H1080.24V252.741Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.95 250.055L1084.55 250.137L1084.61 250.47H1084.95V250.055ZM1086.65 250.055H1087.06V249.64H1086.65V250.055ZM1086.65 252.122V252.537H1087.06V252.122H1086.65ZM1078.38 252.122H1077.96V252.537H1078.38V252.122ZM1078.38 250.055V249.64H1077.96V250.055H1078.38ZM1080.07 250.055V250.47H1080.41L1080.48 250.137L1080.07 250.055ZM1084.95 250.47H1086.65V249.643H1084.95V250.47ZM1086.24 250.055V252.122H1087.06V250.055H1086.24ZM1086.65 251.708H1078.38V252.534H1086.65V251.708ZM1078.79 252.122V250.055H1077.97V252.122H1078.79ZM1078.38 250.47H1080.07V249.643H1078.38V250.47ZM1080.48 250.137C1080.63 249.384 1081.3 248.814 1082.1 248.814V247.987C1080.9 247.987 1079.9 248.839 1079.67 249.972L1080.48 250.137ZM1082.1 248.814H1082.93V247.987H1082.1V248.814ZM1082.93 248.814C1083.72 248.814 1084.4 249.384 1084.55 250.137L1085.36 249.972C1085.13 248.839 1084.13 247.987 1082.93 247.987V248.814Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1084.95 250.053H1086.65V252.121H1078.38V250.053H1080.07C1080.26 249.11 1081.1 248.397 1082.1 248.397H1082.93C1083.93 248.397 1084.76 249.107 1084.95 250.053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.916 262.672C262.658 262.672 264.88 264.895 264.88 267.636V273.842C264.88 276.584 262.658 278.807 259.916 278.807C257.174 278.807 254.951 276.584 254.951 273.842V267.636C254.951 264.895 257.174 262.672 259.916 262.672Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.536 264.119C262.822 264.119 264.674 265.971 264.674 268.257V274.048C264.674 276.334 262.822 278.186 260.536 278.186C258.25 278.186 256.397 276.334 256.397 274.048V268.257C256.397 265.971 258.25 264.119 260.536 264.119Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.707 268.257V283.562",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.81 269.498L259.913 272.395",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.019 272.807L259.916 275.704",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.02 269.498L259.917 272.395",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.08 262.672C285.822 262.672 288.044 264.895 288.044 267.636C288.044 270.378 285.822 272.601 283.08 272.601C280.338 272.601 278.115 270.378 278.115 267.636C278.115 264.895 280.338 262.672 283.08 262.672Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.079 264.535H283.493C285.665 264.535 287.423 266.296 287.423 268.464C287.423 270.636 285.662 272.394 283.493 272.394H283.079C280.907 272.394 279.149 270.633 279.149 268.464C279.149 266.292 280.91 264.535 283.079 264.535Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.873 268.257V283.562",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.767 268.669L282.87 271.566",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.186 268.669L283.083 271.566",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.533 275.527C266.533 273.76 266.898 272.015 267.6 270.397L268.306 268.776C269.677 265.629 274.142 265.629 275.513 268.776L276.219 270.397C276.925 272.015 277.286 273.76 277.286 275.527C277.286 275.967 276.928 276.325 276.488 276.325H267.328C266.888 276.325 266.53 275.967 266.53 275.527H266.533Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.979 275.323C267.979 273.883 268.28 272.458 268.866 271.141L269.202 270.387C270.484 267.5 274.581 267.5 275.863 270.387L276.199 271.141C276.781 272.458 277.085 273.883 277.085 275.323C277.085 275.76 276.731 276.118 276.291 276.118H268.777C268.34 276.118 267.983 275.764 267.983 275.323H267.979Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.912 273.223V283.358",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.6 272.392L271.912 274.874",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.842 273.634L271.909 275.91",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.037 283.328C242.115 281.596 242.387 278.506 244.585 277.138L248.229 274.871C248.793 274.523 249.508 274.536 250.053 274.909L253.285 277.116C255.378 278.547 255.657 281.526 253.865 283.319C253.843 283.341 253.811 283.353 253.779 283.353H244.107C244.081 283.353 244.053 283.344 244.034 283.325L244.037 283.328Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.034 283.325C244.053 283.344 244.081 283.353 244.107 283.353H253.779C253.811 283.353 253.843 283.341 253.865 283.319C255.657 281.526 255.378 278.547 253.285 277.116L250.053 274.909C249.508 274.536 248.793 274.523 248.229 274.871L244.585 277.138C242.387 278.506 242.115 281.596 244.037 283.328L244.034 283.325ZM244.034 283.325L243.895 283.48",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.328 283.062C243.068 281.552 243.473 279.272 245.174 278.284L249.255 275.919C249.705 275.659 250.262 275.666 250.708 275.935L253.504 277.641C255.492 278.854 255.632 281.688 253.776 283.094C253.732 283.128 253.678 283.144 253.621 283.144H244.512C244.439 283.144 244.37 283.113 244.325 283.056L244.328 283.062Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.536 279.84V283.148",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.228 279.013L248.54 281.495",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.469 280.254L248.536 282.53",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.759 283.563H290.022C291.086 283.563 292.109 283.16 292.885 282.435L293.445 281.913C293.629 281.742 293.762 281.527 293.834 281.286L293.885 281.109C294.275 279.795 292.682 278.804 291.675 279.738V279.035C291.675 277.588 289.858 276.939 288.943 278.063C289.38 276.315 287.372 274.989 285.938 276.078L285.53 276.388L285.419 276.043C285.032 274.843 283.728 274.2 282.544 274.628C281.36 275.055 280.764 276.375 281.227 277.544L281.432 278.063C279.672 278.063 278.691 280.092 279.783 281.473L280.609 282.518C281.132 283.176 281.926 283.563 282.765 283.563H282.759Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.147 283.356L282.665 279.427",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.32 281.7L285.767 278.597",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.665 283.563L290.733 280.875",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.459 280.254L289.906 281.701",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.217 283.357L283.079 276.53",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.904 277.344C380.319 275.856 380.601 273.621 379.598 271.829L373.905 261.637C373.351 260.646 371.929 260.646 371.375 261.637L365.514 272.13C364.603 273.763 364.799 275.796 366.015 277.224C366.866 278.228 368.117 278.804 369.434 278.804H375.504C376.789 278.804 378.018 278.275 378.904 277.344Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.563 277.553C379.927 276.28 380.196 274.216 379.199 272.636L374.453 265.104C373.804 264.075 372.3 264.075 371.651 265.104L366.23 273.709C365.619 274.678 365.749 275.938 366.541 276.768C367.665 277.939 369.216 278.601 370.837 278.601H375.903C376.888 278.601 377.838 278.228 378.556 277.556L378.563 277.553Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.642 268.257V283.562",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.538 269.498L372.435 272.395",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.744 272.807L372.847 275.704",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.33 269.498L372.433 272.395",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.314 283.33C390.236 281.598 389.964 278.508 387.767 277.14L384.122 274.873C383.559 274.525 382.843 274.538 382.299 274.911L379.066 277.118C376.973 278.549 376.695 281.528 378.487 283.321C378.509 283.343 378.54 283.355 378.572 283.355H388.245C388.27 283.355 388.299 283.346 388.318 283.327L388.314 283.33Z",
    fill: "#FFD6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.318 283.327C388.299 283.346 388.27 283.355 388.245 283.355H378.572C378.54 283.355 378.509 283.343 378.487 283.321C376.695 281.528 376.973 278.549 379.066 277.118L382.299 274.911C382.843 274.538 383.559 274.525 384.122 274.873L387.767 277.14C389.964 278.508 390.236 281.598 388.314 283.33L388.318 283.327ZM388.318 283.327L388.457 283.482",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.85 283.062C390.11 281.552 389.705 279.272 388.005 278.284L383.923 275.919C383.474 275.659 382.917 275.666 382.47 275.935L379.674 277.641C377.686 278.854 377.547 281.688 379.402 283.094C379.446 283.128 379.5 283.144 379.557 283.144H388.666C388.739 283.144 388.809 283.113 388.853 283.056L388.85 283.062Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.812 279.84V283.148",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.123 279.013L383.811 281.495",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.879 280.253L383.812 282.529",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.32 282.941H-18.9053V295.764H1337.32V282.941Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.32 285.629H-19.1104V295.558H1337.32V285.629Z",
    fill: "#A9D395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.4043 295.558H262.068L168.578 292.661H57.299L-18.4043 295.558Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.077 295.558H502.124L422.286 292.661H311.008L174.08 295.558H174.077Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.926 295.558H962.959L829.34 292.661H569.137L459.926 295.558Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.91 295.558H1337.32V292.661H1125.12L1015.91 295.558Z",
    fill: "#6F9392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.57 289.767C751.453 290.941 750.465 291.834 749.287 291.834H748.986C747.77 291.834 746.732 290.963 746.52 289.767C746.33 290.957 745.288 291.834 744.079 291.834C742.866 291.834 741.812 290.96 741.599 289.767C741.384 290.963 740.342 291.834 739.127 291.834H738.965C737.749 291.834 736.711 290.963 736.499 289.767L736.423 290.118C736.207 291.122 735.321 291.837 734.295 291.837H734.191C733.048 291.837 732.123 290.91 732.123 289.77",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M553.087 299.212C550.383 298.31 548.325 299.589 547.638 300.339C547.384 300.463 546.846 300.602 546.697 300.152C548.198 298.462 551.206 297.898 553.083 299.212H553.087Z",
    fill: "url(#paint4_linear_6001_48532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.487 289.926V291.265L228.27 291.11C227.89 290.35 227.114 289.872 226.265 289.872H214.541C214.513 289.872 214.487 289.897 214.487 289.926Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.312 305.823H201.794C201.794 306.507 201.24 307.064 200.553 307.064H199.312V305.823Z",
    fill: "#B7594C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.43 275.082H1033.24L1060.92 288.32H1019.43V275.082Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.77 275.082H1019.43V288.32H1029.77V275.082Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.46 278.391H1022.74V288.32H1026.46V278.391Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.19 274.183L1025.96 270.754H1025.92L1025.03 272.645L1024.11 270.735L1022.86 274.18H1022.53V274.456H1024.31V274.18H1023.96L1024.31 273.104L1025.03 274.459L1025.73 273.104L1026.08 274.18H1025.73V274.456H1027.49V274.18H1027.19L1027.19 274.183Z",
    fill: "#B7594C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.461 289.175C645.461 287.408 645.825 285.664 646.528 284.046L647.234 282.425C648.602 279.278 653.073 279.278 654.44 282.425L655.146 284.046C655.849 285.664 656.214 287.408 656.214 289.175C656.214 289.615 655.859 289.973 655.416 289.973H646.256C645.813 289.973 645.458 289.615 645.458 289.175H645.461Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.912 288.972C646.912 287.531 647.213 286.106 647.799 284.789L648.134 284.036C649.417 281.148 653.514 281.148 654.796 284.036L655.132 284.789C655.714 286.106 656.018 287.531 656.018 288.972C656.018 289.409 655.663 289.767 655.223 289.767H647.71C647.27 289.767 646.915 289.412 646.915 288.972H646.912Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.841 286.871V290.18",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.529 286.044L650.841 288.526",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.774 287.285L650.842 289.562",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.002 289.945C616.077 288.213 616.352 285.123 618.546 283.755L622.19 281.488C622.754 281.14 623.47 281.153 624.014 281.526L627.25 283.733C629.343 285.164 629.621 288.144 627.829 289.936C627.804 289.958 627.776 289.971 627.744 289.971H618.071C618.046 289.971 618.021 289.961 618.002 289.942V289.945Z",
    fill: "#FFD6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.002 289.942C618.021 289.961 618.046 289.971 618.071 289.971H627.744C627.776 289.971 627.804 289.958 627.829 289.936C629.621 288.144 629.343 285.164 627.25 283.733L624.014 281.526C623.47 281.153 622.754 281.14 622.19 281.488L618.546 283.755C616.352 285.123 616.077 288.213 618.002 289.945V289.942ZM618.002 289.942L617.862 290.097",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.293 289.68C617.036 288.17 617.441 285.89 619.141 284.902L623.219 282.537C623.669 282.278 624.229 282.284 624.673 282.553L627.468 284.26C629.457 285.472 629.599 288.306 627.741 289.712C627.699 289.747 627.646 289.762 627.589 289.762H618.483C618.407 289.762 618.343 289.731 618.293 289.674V289.68Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.503 286.46V289.769",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.191 285.629L622.503 288.111",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.436 286.871L622.503 289.148",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.724 290.179H663.987C665.051 290.179 666.07 289.777 666.849 289.052L667.406 288.529C667.593 288.358 667.726 288.143 667.796 287.902L667.85 287.725C668.239 286.411 666.646 285.42 665.64 286.354V285.651C665.64 284.204 663.819 283.555 662.904 284.679C663.341 282.931 661.337 281.605 659.896 282.694L659.488 283.004L659.38 282.659C658.991 281.459 657.689 280.816 656.502 281.244C655.318 281.671 654.723 282.992 655.188 284.16L655.394 284.679C653.637 284.679 652.652 286.709 653.744 288.089L654.567 289.134C655.09 289.792 655.881 290.179 656.724 290.179Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.114 289.973L656.632 286.044",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.287 288.318L659.734 285.215",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.629 290.178L664.696 287.49",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.423 286.871L663.87 288.318",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.182 289.974L657.044 283.147",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3489 289.175C61.3489 287.408 61.713 285.664 62.4159 284.046L63.1219 282.425C64.4929 279.278 68.9572 279.278 70.3281 282.425L71.0342 284.046C71.7403 285.664 72.1012 287.408 72.1012 289.175C72.1012 289.615 71.7434 289.973 71.3033 289.973H62.1436C61.7035 289.973 61.3457 289.615 61.3457 289.175H61.3489Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7949 288.973C62.7949 287.532 63.0957 286.107 63.6815 284.79L64.0171 284.037C65.2994 281.149 69.3964 281.149 70.6787 284.037L71.0143 284.79C71.5969 286.107 71.9009 287.532 71.9009 288.973C71.9009 289.41 71.5462 289.768 71.1061 289.768H63.5928C63.1559 289.768 62.7981 289.413 62.7981 288.973H62.7949Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7246 286.87V290.179",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4166 286.044L66.7285 288.526",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6572 287.285L66.7247 289.562",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8886 289.944C31.9668 288.212 32.2391 285.122 34.4364 283.754L38.0807 281.487C38.6442 281.139 39.3598 281.152 39.9044 281.525L43.137 283.732C45.2299 285.163 45.5085 288.143 43.7165 289.935C43.6943 289.957 43.6626 289.97 43.631 289.97H33.9583C33.933 289.97 33.9045 289.96 33.8855 289.941L33.8886 289.944Z",
    fill: "#FFD6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8855 289.941C33.9045 289.96 33.933 289.97 33.9583 289.97H43.631C43.6626 289.97 43.6943 289.957 43.7165 289.935C45.5085 288.143 45.2299 285.163 43.137 283.732L39.9044 281.525C39.3598 281.152 38.6442 281.139 38.0807 281.487L34.4364 283.754C32.2391 285.122 31.9668 288.212 33.8886 289.944L33.8855 289.941ZM33.8855 289.941L33.7462 290.096",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1799 289.679C32.9198 288.169 33.325 285.889 35.0253 284.901L39.1065 282.536C39.5561 282.277 40.1133 282.283 40.5598 282.552L43.3555 284.259C45.3439 285.471 45.4832 288.305 43.6278 289.711C43.5835 289.746 43.5296 289.761 43.4726 289.761H34.3636C34.2907 289.761 34.2211 289.73 34.1768 289.673L34.1799 289.679Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3906 286.457V289.766",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0787 285.629L38.3906 288.111",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3203 286.87L38.3878 289.147",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6107 290.179H79.8739C80.9377 290.179 81.9604 289.777 82.7361 289.052L83.2965 288.529C83.4802 288.358 83.6132 288.143 83.686 287.902L83.7366 287.725C84.1261 286.411 82.5335 285.42 81.5266 286.354V285.651C81.5266 284.204 79.7093 283.555 78.7942 284.679C79.2312 282.931 77.2238 281.605 75.7895 282.694L75.3811 283.004L75.2703 282.659C74.884 281.459 73.5795 280.816 72.3954 281.244C71.2112 281.671 70.616 282.992 71.0782 284.16L71.284 284.679C69.5236 284.679 68.5421 286.709 69.6345 288.089L70.4608 289.134C70.9833 289.792 71.778 290.179 72.617 290.179H72.6107Z",
    fill: "#62AE80",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0008 289.973L72.5186 286.044",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1719 288.316L75.6188 285.213",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5156 290.178L80.5831 287.49",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3096 286.87L79.7565 288.317",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0689 289.973L72.9307 283.146",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.59 287.522C1066.59 285.755 1066.22 284.011 1065.52 282.393L1064.81 280.772C1063.44 277.624 1058.97 277.624 1057.61 280.772L1056.9 282.393C1056.2 284.011 1055.83 285.755 1055.83 287.522C1055.83 287.962 1056.19 288.32 1056.63 288.32H1065.79C1066.23 288.32 1066.59 287.962 1066.59 287.522H1066.59Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.14 287.32C1065.14 285.879 1064.84 284.454 1064.25 283.137L1063.92 282.383C1062.63 279.496 1058.54 279.496 1057.25 282.383L1056.92 283.137C1056.34 284.454 1056.03 285.879 1056.03 287.32C1056.03 287.756 1056.39 288.114 1056.83 288.114H1064.34C1064.78 288.114 1065.13 287.76 1065.13 287.32H1065.14Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.21 285.217V288.525",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.52 284.388L1061.21 286.87",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.28 285.629L1061.21 287.905",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.33 288.526H1048.06C1047 288.526 1045.98 288.124 1045.2 287.399L1044.64 286.877C1044.46 286.706 1044.32 286.491 1044.25 286.25L1044.2 286.073C1043.81 284.759 1045.4 283.768 1046.41 284.702V283.999C1046.41 282.552 1048.23 281.903 1049.15 283.027C1048.71 281.279 1050.71 279.952 1052.15 281.042L1052.56 281.352L1052.67 281.007C1053.06 279.807 1054.36 279.164 1055.55 279.591C1056.73 280.019 1057.33 281.339 1056.86 282.507L1056.66 283.027C1058.41 283.027 1059.4 285.056 1058.31 286.437L1057.48 287.482C1056.96 288.14 1056.17 288.526 1055.33 288.526Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.94 288.317L1055.42 284.388",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.76 286.664L1052.32 283.562",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.42 288.527L1047.35 285.839",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.63 285.217L1048.18 286.664",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.87 288.318L1055 281.492",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3647 281.598C13.3647 281.312 13.1322 281.079 12.8454 281.079C12.5587 281.079 12.3262 281.312 12.3262 281.598V289.897C12.3262 290.184 12.5587 290.416 12.8454 290.416C13.1322 290.416 13.3647 290.184 13.3647 289.897V281.598Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.003 281.77H13.3643V285.227H31.003V281.77Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.003 284.191H13.3643V284.537H31.003V284.191Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.003 282.809H13.3643V283.154H31.003V282.809Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9648 281.598C29.9648 281.31 30.196 281.079 30.4841 281.079C30.7722 281.079 31.0034 281.31 31.0034 281.598V289.9C31.0034 290.185 30.7722 290.419 30.4841 290.419C30.196 290.419 29.9648 290.188 29.9648 289.9V281.598Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1332 287.477C16.1332 287.19 15.9008 286.958 15.614 286.958C15.3272 286.958 15.0947 287.19 15.0947 287.477V290.59C15.0947 290.876 15.3272 291.109 15.614 291.109C15.9008 291.109 16.1332 290.876 16.1332 290.59V287.477Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4262 287.477C33.4262 287.19 33.1937 286.958 32.9069 286.958C32.6202 286.958 32.3877 287.19 32.3877 287.477V290.59C32.3877 290.876 32.6202 291.109 32.9069 291.109C33.1937 291.109 33.4262 290.876 33.4262 290.59V287.477Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3657 286.958L12.3271 286.094H31.0044L33.4266 286.958V287.997H15.0944L13.3657 286.958Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4269 286.958H15.0947V287.997H33.4269V286.958Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3271 286.094L15.0944 286.958V288.342L12.3271 287.132V286.094Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.305 281.079C595.59 281.079 595.825 281.31 595.825 281.598V289.9C595.825 290.185 595.593 290.419 595.305 290.419C595.02 290.419 594.786 290.188 594.786 289.9V281.598C594.786 281.313 595.017 281.079 595.305 281.079Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.464 281.77H595.825V285.227H613.464V281.77Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.464 284.191H595.825V284.537H613.464V284.191Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.464 282.809H595.825V283.154H613.464V282.809Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.425 281.598C612.425 281.31 612.656 281.079 612.941 281.079C613.226 281.079 613.463 281.31 613.463 281.598V289.9C613.463 290.185 613.232 290.419 612.941 290.419C612.65 290.419 612.425 290.188 612.425 289.9V281.598Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.072 286.958C598.357 286.958 598.591 287.189 598.591 287.477V290.59C598.591 290.875 598.36 291.109 598.072 291.109C597.787 291.109 597.553 290.878 597.553 290.59V287.477C597.553 287.192 597.784 286.958 598.072 286.958Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.363 286.958C615.648 286.958 615.882 287.189 615.882 287.477V290.59C615.882 290.875 615.651 291.109 615.363 291.109C615.078 291.109 614.844 290.878 614.844 290.59V287.477C614.844 287.192 615.075 286.958 615.363 286.958Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.825 286.958L594.786 286.094H613.463L615.882 286.958V287.997H597.553L595.825 286.958Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.885 286.958H597.553V287.997H615.885V286.958Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.786 286.094L597.553 286.958V288.342L594.786 287.132V286.094Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.271 284.221C999.471 284.221 999.636 284.383 999.636 284.585V290.409C999.636 290.609 999.474 290.774 999.271 290.774C999.072 290.774 998.907 290.611 998.907 290.409V284.585C998.907 284.385 999.069 284.221 999.271 284.221Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.01 284.705H999.636V287.131H1012.01V284.705Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.01 286.404H999.636V286.646H1012.01V286.404Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.01 285.434H999.636V285.676H1012.01V285.434Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.28 284.585C1011.28 284.383 1011.44 284.221 1011.64 284.221C1011.84 284.221 1012.01 284.383 1012.01 284.585V290.409C1012.01 290.609 1011.85 290.774 1011.64 290.774C1011.44 290.774 1011.28 290.611 1011.28 290.409V284.585Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.21 288.345C1001.41 288.345 1001.58 288.507 1001.58 288.709V290.893C1001.58 291.092 1001.42 291.257 1001.21 291.257C1001.01 291.257 1000.85 291.095 1000.85 290.893V288.709C1000.85 288.509 1001.01 288.345 1001.21 288.345Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.34 288.345C1013.54 288.345 1013.71 288.507 1013.71 288.709V290.893C1013.71 291.092 1013.55 291.257 1013.34 291.257C1013.14 291.257 1012.98 291.095 1012.98 290.893V288.709C1012.98 288.509 1013.14 288.345 1013.34 288.345Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.637 288.346L998.908 287.739H1012.01L1013.71 288.346V289.074H1000.85L999.637 288.346Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.71 288.345H1000.85V289.073H1013.71V288.345Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.908 287.739L1000.85 288.346V289.316L998.908 288.468V287.739Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.288 282.439C684.088 282.439 683.924 282.602 683.924 282.804V288.628C683.924 288.828 684.086 288.992 684.288 288.992C684.488 288.992 684.652 288.83 684.652 288.628V282.804C684.652 282.604 684.49 282.439 684.288 282.439Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.549 282.924H683.924V285.349H671.549V282.924Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.549 284.623H683.924V284.865H671.549V284.623Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.549 283.652H683.924V283.894H671.549V283.652Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.277 282.804C672.277 282.602 672.115 282.439 671.915 282.439C671.715 282.439 671.549 282.602 671.549 282.804V288.628C671.549 288.828 671.711 288.992 671.915 288.992C672.12 288.992 672.277 288.83 672.277 288.628V282.804Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.347 286.563C682.147 286.563 681.982 286.726 681.982 286.928V289.111C681.982 289.311 682.145 289.476 682.347 289.476C682.547 289.476 682.711 289.313 682.711 289.111V286.928C682.711 286.728 682.549 286.563 682.347 286.563Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.216 286.563C670.016 286.563 669.852 286.726 669.852 286.928V289.111C669.852 289.311 670.014 289.476 670.216 289.476C670.416 289.476 670.58 289.313 670.58 289.111V286.928C670.58 286.728 670.418 286.563 670.216 286.563Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.923 286.564L684.651 285.958H671.548L669.851 286.564V287.293H682.71L683.923 286.564Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.85 286.563H682.711V287.292H669.85V286.563Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.651 285.958L682.71 286.564V287.535L684.651 286.687V285.958Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.575 279.48C225.745 279.48 225.884 279.618 225.884 279.79V284.745C225.884 284.915 225.746 285.055 225.575 285.055C225.404 285.055 225.265 284.917 225.265 284.745V279.79C225.265 279.62 225.403 279.48 225.575 279.48Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.412 279.893H225.885V281.956H236.412V279.893Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.412 281.338H225.885V281.544H236.412V281.338Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.412 280.513H225.885V280.719H236.412V280.513Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.792 279.79C235.792 279.618 235.93 279.48 236.1 279.48C236.27 279.48 236.412 279.618 236.412 279.79V284.745C236.412 284.915 236.274 285.055 236.1 285.055C235.926 285.055 235.792 284.917 235.792 284.745V279.79Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.226 282.989C227.396 282.989 227.536 283.127 227.536 283.299V285.157C227.536 285.327 227.398 285.467 227.226 285.467C227.056 285.467 226.916 285.329 226.916 285.157V283.299C226.916 283.129 227.054 282.989 227.226 282.989Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.546 282.989C237.716 282.989 237.856 283.127 237.856 283.299V285.157C237.856 285.327 237.718 285.467 237.546 285.467C237.376 285.467 237.236 285.329 237.236 285.157V283.299C237.236 283.129 237.374 282.989 237.546 282.989Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.885 282.99L225.266 282.474H236.413L237.857 282.99V283.609H226.917L225.885 282.99Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.857 282.989H226.916V283.609H237.857V282.989Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.266 282.474L226.917 282.99V283.815L225.266 283.093V282.474Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.526 168.788H160.067L163.953 167.171C165.245 166.632 166.712 166.68 167.966 167.307C168.626 166.646 170.632 165.529 173.396 166.321C169.84 167.113 168.296 169.284 167.966 170.27C166.683 169.308 165.124 168.788 163.521 168.788H163.526Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.827 127.822H257.368L261.254 126.204C262.551 125.665 264.013 125.714 265.266 126.34C265.927 125.685 267.933 124.563 270.697 125.354C267.141 126.146 265.597 128.317 265.266 129.303C263.984 128.342 262.425 127.822 260.822 127.822H260.827Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.43 164.357H1070.88L1067 162.74C1065.7 162.2 1064.24 162.249 1062.99 162.876C1062.33 162.22 1060.32 161.098 1057.56 161.89C1061.11 162.681 1062.66 164.853 1062.99 165.839C1064.27 164.877 1065.83 164.357 1067.43 164.357H1067.43Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.32 320.378H-19.1104V325.301H1337.32V320.378Z",
    fill: "#C3E1B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.32 324.861H-19.1104V328.236H1337.32V324.861Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.32 286.044C417.199 286.76 416.579 287.285 415.854 287.285H413.926C413.156 287.285 412.482 286.778 412.267 286.044C412.073 286.775 411.415 287.285 410.658 287.285H409.009C408.239 287.285 407.565 286.778 407.349 286.044C407.131 286.782 406.45 287.285 405.681 287.285H403.905C403.135 287.285 402.461 286.778 402.246 286.044C401.98 286.788 401.274 287.285 400.488 287.285H399.114C398.427 287.285 397.873 286.731 397.873 286.044",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.224 289.767C384.106 290.941 383.119 291.834 381.938 291.834H381.637C380.421 291.834 379.382 290.963 379.174 289.767C378.987 290.957 377.939 291.834 376.732 291.834C375.52 291.834 374.462 290.96 374.253 289.767C374.038 290.963 372.996 291.834 371.78 291.834H371.619C370.403 291.834 369.365 290.963 369.156 289.767L369.08 290.118C368.864 291.122 367.981 291.837 366.955 291.837H366.851C365.708 291.837 364.783 290.91 364.783 289.77",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.351 286.044C182.231 286.76 181.613 287.285 180.885 287.285H178.957C178.191 287.285 177.516 286.778 177.298 286.044C177.105 286.775 176.443 287.285 175.69 287.285H174.037C173.271 287.285 172.596 286.778 172.378 286.044C172.156 286.782 171.479 287.285 170.709 287.285H168.933C168.167 287.285 167.492 286.778 167.274 286.044C167.008 286.788 166.305 287.285 165.513 287.285H164.143C163.459 287.285 162.901 286.731 162.901 286.044",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.255 289.767C149.138 290.941 148.15 291.834 146.969 291.834H146.668C145.452 291.834 144.414 290.963 144.205 289.767C144.018 290.957 142.97 291.834 141.764 291.834C140.551 291.834 139.493 290.96 139.285 289.767C139.069 290.963 138.028 291.834 136.812 291.834H136.65C135.434 291.834 134.396 290.963 134.187 289.767L134.111 290.118C133.896 291.122 133.012 291.837 131.986 291.837H131.882C130.739 291.837 129.814 290.91 129.814 289.77",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.459 286.044C536.339 286.76 535.718 287.285 534.993 287.285H533.065C532.296 287.285 531.621 286.778 531.406 286.044C531.213 286.775 530.554 287.285 529.798 287.285H528.148C527.379 287.285 526.704 286.778 526.489 286.044C526.271 286.782 525.59 287.285 524.821 287.285H523.044C522.275 287.285 521.6 286.778 521.385 286.044C521.119 286.788 520.413 287.285 519.628 287.285H518.254C517.567 287.285 517.013 286.731 517.013 286.044",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.363 289.767C503.246 290.941 502.258 291.834 501.08 291.834H500.779C499.563 291.834 498.525 290.963 498.313 289.767C498.123 290.957 497.081 291.834 495.872 291.834C494.659 291.834 493.605 290.96 493.392 289.767C493.177 290.963 492.135 291.834 490.92 291.834H490.758C489.542 291.834 488.504 290.963 488.292 289.767L488.216 290.118C488 291.122 487.114 291.837 486.088 291.837H485.984C484.841 291.837 483.916 290.91 483.916 289.77",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.666 286.044C784.546 286.76 783.926 287.285 783.2 287.285H781.272C780.503 287.285 779.828 286.778 779.613 286.044C779.42 286.775 778.761 287.285 778.005 287.285H776.355C775.586 287.285 774.911 286.778 774.696 286.044C774.478 286.782 773.797 287.285 773.027 287.285H771.251C770.482 287.285 769.807 286.778 769.592 286.044C769.326 286.788 768.62 287.285 767.835 287.285H766.461C765.774 287.285 765.22 286.731 765.22 286.044",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.037 287.749C959.917 288.465 959.297 288.99 958.572 288.99H956.643C955.874 288.99 955.2 288.484 954.984 287.749C954.791 288.48 954.133 288.99 953.376 288.99H951.726C950.957 288.99 950.282 288.484 950.067 287.749C949.849 288.487 949.168 288.99 948.399 288.99H946.622C945.853 288.99 945.179 288.484 944.963 287.749C944.697 288.493 943.991 288.99 943.206 288.99H941.832C941.145 288.99 940.591 288.436 940.591 287.749",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.33 289.767C877.213 290.941 876.225 291.834 875.048 291.834H874.747C873.531 291.834 872.493 290.963 872.28 289.767C872.09 290.957 871.049 291.834 869.839 291.834C868.627 291.834 867.572 290.96 867.36 289.767C867.145 290.963 866.103 291.834 864.887 291.834H864.726C863.51 291.834 862.472 290.963 862.259 289.767L862.183 290.118C861.968 291.122 861.082 291.837 860.056 291.837H859.951C858.808 291.837 857.884 290.91 857.884 289.77",
    stroke: "#615E66",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.607 259.363C501.349 259.363 503.572 261.586 503.572 264.328V270.534C503.572 273.275 501.349 275.498 498.607 275.498C495.865 275.498 493.643 273.275 493.643 270.534V264.328C493.643 261.586 495.865 259.363 498.607 259.363Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.227 260.81C501.513 260.81 503.365 262.662 503.365 264.948V270.739C503.365 273.025 501.513 274.877 499.227 274.877C496.941 274.877 495.089 273.025 495.089 270.739V264.948C495.089 262.662 496.941 260.81 499.227 260.81Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.398 264.944V283.147",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.5 266.187L498.397 269.638",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.71 269.498L498.398 272.186",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.71 266.187L498.398 268.875",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.498 266.808C516.24 266.808 518.462 269.03 518.462 271.772C518.462 274.514 516.24 276.737 513.498 276.737C510.756 276.737 508.533 274.514 508.533 271.772C508.533 269.03 510.756 266.808 513.498 266.808Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.498 268.669H513.912C516.084 268.669 517.842 270.429 517.842 272.598C517.842 274.77 516.081 276.527 513.912 276.527H513.498C511.326 276.527 509.568 274.767 509.568 272.598C509.568 270.426 511.329 268.669 513.498 268.669Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.292 272.394V282.943",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.185 272.807L513.288 275.704",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.604 272.807L513.501 275.704",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.249 282.943C485.249 282.943 485.176 282.854 485.141 282.81C483.767 281.034 484.179 278.38 486.17 277.139L489.814 274.872C490.378 274.524 491.094 274.537 491.638 274.91L494.874 277.117C496.764 278.409 497.173 280.964 495.916 282.769C495.874 282.826 495.789 282.943 495.789 282.943H485.252H485.249Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.904 282.698C484.663 281.207 485.062 278.959 486.74 277.983L490.764 275.65C491.211 275.394 491.761 275.4 492.195 275.666L494.953 277.35C496.916 278.547 497.055 281.343 495.222 282.73C495.181 282.761 495.127 282.78 495.07 282.78H486.088C486.015 282.78 485.948 282.749 485.901 282.695L485.904 282.698Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.125 279.839V282.942",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.813 279.013L490.125 281.495",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.058 280.254L490.125 282.53",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.71 282.942C512.71 282.942 513.169 282.629 513.374 282.435L513.932 281.913C514.119 281.742 514.251 281.527 514.321 281.286L514.375 281.109C514.764 279.795 513.172 278.804 512.165 279.738V279.035C512.165 277.588 510.344 276.939 509.429 278.063C509.866 276.315 507.862 274.989 506.422 276.078L506.013 276.388L505.905 276.043C505.516 274.843 504.215 274.2 503.027 274.628C501.843 275.055 501.248 276.375 501.713 277.544L501.919 278.063C500.162 278.063 499.177 280.092 500.27 281.473L501.093 282.518C501.216 282.676 501.511 282.942 501.511 282.942H512.71Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.376 282.942L503.156 279.425",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.503 281.558L506.26 278.598",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.632 282.943L511.224 280.875",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.947 280.254L510.53 281.774",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.456 282.944L503.571 276.532",
    stroke: "#615E66",
    strokeWidth: 0.316618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.8477 305.417H1082.15V331.386H-10.8477V305.417Z",
    fill: "#CFCDC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.82 313.681L-4.76362 313.53",
    stroke: "white",
    strokeWidth: 0.837268,
    strokeDasharray: "4.19 4.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.8477 330.949H1082.15V337.647H-10.8477V330.949Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.8477 298.714H1082.15V305.412H-10.8477V298.714Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.8477 292.477H1082.15V302.823H-10.8477V292.477Z",
    fill: "#A9D395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.58 302.825H855.58L930.914 299.806H1020.58L1081.58 302.825Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.483 302.825H662.145L726.478 299.806H816.145L926.48 302.825H926.483Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.148 302.825H290.809L398.478 299.806H608.147L696.148 302.825Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.11 473.572V338.698L-0.350342 338.698V473.572L1080.11 473.572Z",
    fill: "#F9D5C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.35 493.198V471.946L-60.3119 471.946V493.198L1113.35 493.198Z",
    fill: "url(#paint5_linear_6001_48532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.4 471.699V337.699L-8.5144 337.699V471.699L1091.4 471.699Z",
    fill: "#C4E1B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.15 471.58H-8.80957V456.93H1102.15V471.58Z",
    fill: "#C3E1B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.152 366.699L227.01 367.565L344.112 433.016H725.542L736.152 366.699Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.103 345.126C182.472 344.273 180.659 343.828 178.818 343.828H-15.0812L-15.6514 363.743H140.386C141.257 363.743 142.116 363.943 142.898 364.327L180.297 382.682L259.16 433.016H344.112L227.01 367.565L184.103 345.126Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.16 433.016L180.297 382.682H-9.17732L-8.80959 433.016H259.16Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.914 433.016L887.464 432.583L1099.56 433.016L1091.58 393.185L873.51 392.079C848.656 391.953 824.267 385.33 802.763 372.868L780.007 359.68C777.468 358.208 778.54 354.324 781.474 354.363L1097.28 358.548V343.828L735.091 342.173C728.07 342.141 724.004 350.115 728.153 355.779L736.152 366.699L725.542 433.016H813.914Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.777 390.348C888.777 390.348 891.256 387.687 891.326 384.915C891.396 382.143 888.012 384.915 888.012 384.915C888.012 384.915 888.575 383.724 887.801 383.417C887.027 383.113 885.331 385.081 885.331 385.081C885.331 385.081 885.285 379.868 882.133 379.387C878.984 378.906 878.09 381.753 878.09 381.753C878.09 381.753 877.478 379.648 876.303 379.608C875.128 379.573 875.314 381.162 875.314 381.162C875.314 381.162 873.808 378.575 870.142 379.092C866.476 379.608 865.864 383.637 865.864 383.637C865.864 383.637 864.701 382.336 863.609 382.612C862.517 382.888 863.22 385.688 863.22 385.688C863.22 385.688 861.246 382.084 859.906 382.056C858.565 382.029 859.484 385.132 859.484 385.132C859.484 385.132 858.04 381.28 853.596 380.558C849.152 379.837 850.741 384.682 850.741 384.682C850.741 384.682 848.941 383.22 847.886 383.634C846.831 384.048 848.838 386.934 848.838 386.934C848.838 386.934 846.264 385.463 844.642 386.074C843.021 386.685 846.451 390.344 846.451 390.344H888.773L888.777 390.348Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.285074
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.255 457.168C769.255 457.168 771.733 454.507 771.804 451.735C771.874 448.964 768.489 451.735 768.489 451.735C768.489 451.735 769.052 450.545 768.278 450.237C767.505 449.933 765.808 451.901 765.808 451.901C765.808 451.901 765.763 446.689 762.61 446.208C759.461 445.727 758.568 448.573 758.568 448.573C758.568 448.573 757.955 446.468 756.78 446.428C755.605 446.393 755.791 447.982 755.791 447.982C755.791 447.982 754.285 445.395 750.62 445.912C746.954 446.428 746.341 450.458 746.341 450.458C746.341 450.458 745.179 449.157 744.086 449.433C742.994 449.709 743.697 452.508 743.697 452.508C743.697 452.508 741.724 448.904 740.383 448.877C739.043 448.849 739.961 451.952 739.961 451.952C739.961 451.952 738.517 448.1 734.074 447.379C729.63 446.657 731.219 451.503 731.219 451.503C731.219 451.503 729.419 450.04 728.364 450.454C727.309 450.868 729.315 453.754 729.315 453.754C729.315 453.754 726.742 452.283 725.12 452.894C723.498 453.505 726.928 457.164 726.928 457.164H769.251L769.255 457.168Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.285074
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.634 364.31C133.634 364.31 135.392 362.422 135.442 360.457C135.492 358.491 133.091 360.457 133.091 360.457C133.091 360.457 133.49 359.612 132.942 359.394C132.393 359.179 131.19 360.574 131.19 360.574C131.19 360.574 131.157 356.878 128.921 356.536C126.688 356.195 126.054 358.214 126.054 358.214C126.054 358.214 125.62 356.721 124.787 356.693C123.953 356.668 124.085 357.795 124.085 357.795C124.085 357.795 123.017 355.96 120.417 356.327C117.818 356.693 117.383 359.551 117.383 359.551C117.383 359.551 116.559 358.628 115.784 358.824C115.009 359.019 115.508 361.005 115.508 361.005C115.508 361.005 114.109 358.449 113.158 358.429C112.207 358.41 112.858 360.61 112.858 360.61C112.858 360.61 111.834 357.879 108.683 357.367C105.531 356.855 106.658 360.292 106.658 360.292C106.658 360.292 105.382 359.254 104.633 359.548C103.885 359.842 105.308 361.888 105.308 361.888C105.308 361.888 103.483 360.845 102.333 361.279C101.182 361.712 103.615 364.307 103.615 364.307H133.631L133.634 364.31Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.20218
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.006 424.946C131.006 424.946 126.108 427.029 127.926 433.589H161.91C162.293 432.707 162.57 431.689 162.652 430.528C161.035 425.873 158.175 426.346 158.175 426.346C158.175 426.346 159.567 424.345 158.835 424.058C158.103 423.771 156.855 424.785 156.855 424.785C156.855 424.785 157.957 421.424 154.875 421.925C151.793 422.425 150.791 425.097 150.791 425.097C150.791 425.097 151.428 422.945 150.499 422.964C149.569 422.983 148.2 425.482 148.2 425.482C148.2 425.482 148.688 423.541 147.93 423.35C147.173 423.158 146.366 424.06 146.366 424.06C146.366 424.06 145.942 421.266 143.399 420.908C140.857 420.549 139.812 422.343 139.812 422.343C139.812 422.343 139.941 421.241 139.126 421.266C138.312 421.293 137.887 422.753 137.887 422.753C137.887 422.753 137.267 420.779 135.083 421.113C132.897 421.446 132.865 425.061 132.865 425.061C132.865 425.061 131.689 423.697 131.152 423.907C130.615 424.121 131.006 424.946 131.006 424.946Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.285074
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6001_48532",
    x1: 97.9795,
    y1: -0.0000307697,
    x2: 1185.52,
    y2: 487.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF9FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6001_48532",
    x1: -10.8671,
    y1: 529.557,
    x2: 106.731,
    y2: 1042.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727BBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6001_48532",
    x1: 1967.69,
    y1: 310.467,
    x2: 1967.69,
    y2: 158.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1CADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6001_48532",
    x1: 1967.69,
    y1: 310.467,
    x2: 1967.69,
    y2: 158.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1CADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6001_48532",
    x1: 546.672,
    y1: 299.716,
    x2: 554.746,
    y2: 298.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6001_48532",
    x1: 526.521,
    y1: 471.946,
    x2: 526.521,
    y2: 493.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6001_48532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 493,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackPlanTablet);
export default __webpack_public_path__ + "static/media/BackPlanTablet.9e9763076b64708f2096.svg";
export { ForwardRef as ReactComponent };